module.exports = {
    "enus": {
        "P_YS_SD_SDMAF_0000136493": "Send Email",
        "P_YS_PF_MES-FE_0001269113": "Document title",
        "P_YS_FI_CM_0000026181": "Yes",
        "P_YS_PF_PROCENTER_0000027341": "App",
        "P_YS_SD_SDMAUF_0000153186": "Enterprise Addr.",
        "P_YS_PF_WORKBENCH-FE_0001133355": "Product Module Customization",
        "P_YS_PF_WORKBENCH-FE_0001133356": " days before expiration",
        "P_YS_PF_WORKBENCH-FE_0001133353": "so I can manage and keep track of business operations anytime.",
        "P_YS_PF_WORKBENCH-FE_0001133354": "Modify Business Date",
        "P_YS_PF_WORKBENCH-FE_0001133359": "Preferences",
        "P_YS_PF_WORKBENCH-FE_0001228612": "Page Property Settings",
        "P_YS_PF_WORKBENCH-FE_0001228611": "Picture Ambiguity",
        "P_YS_PF_WORKBENCH-FE_0001133357": "Homepage Settings",
        "P_YS_PF_WORKBENCH-FE_0001228610": "Picture Mask",
        "P_YS_PF_WORKBENCH-FE_0001133358": "Portal",
        "P_YS_PF_WORKBENCH-FE_0001133362": "You can open up to 20 pages. Please close the pages you don't need.",
        "P_YS_PF_WORKBENCH-FE_0001228609": "Card Spacing",
        "P_YS_PF_GZTSYS_0000012650": "App Mgmt",
        "P_YS_PF_WORKBENCH-FE_0001133363": "Now I have the energy to pay more attention to each employee, empowering and activating the team.",
        "P_YS_PF_WORKBENCH-FE_0001228608": "Page Width",
        "P_YS_PF_WORKBENCH-FE_0001133360": "After quitting from a team, the Apps under the team will no longer be available, and the relevant data will be deleted. Please confirm that the data has been backed up.",
        "P_YS_PF_WORKBENCH-FE_0001228607": "Fixed Width",
        "P_YS_PF_WORKBENCH-FE_0001133361": "No result found",
        "P_YS_SD_SDMA-UI_0001140473": "Component Link",
        "P_YS_FI_ETL_0000111653": "Local",
        "P_YS_PF_WORKBENCH-FE_0001233073": "The menu structure has changed",
        "P_YS_PF_WORKBENCH-FE_0001233072": "Switch to Old Version",
        "P_YS_FED_UCFBASEDOC_0000025292": "Not Added",
        "P_YS_PF_WORKBENCH-FE_0001233071": "New Menu",
        "P_YS_PF_WORKBENCH-FE_0001133366": "Yonyou Network Technology Co., Ltd ? Copyright 2018 Beijing ICP No. 5007539-24 Beijing ICP No. 100714",
        "P_YS_PF_WORKBENCH-FE_0001233070": "Switch Personalized Config. and Tenants",
        "P_YS_PF_WORKBENCH-FE_0001133367": "Search for functions,  contacts, etc.",
        "P_YS_PF_WORKBENCH-FE_0001133364": " Starry Blue",
        "P_YS_PF_WORKBENCH-FE_0001133365": "Exclusive Customizations",
        "P_YS_PF_WORKBENCH-FE_0001228600": "Welcome to YouZone",
        "P_YS_PF_WORKBENCH-FE_0001133368": "Service Function Release",
        "P_YS_PF_WORKBENCH-FE_0001133369": "Email",
        "P_YS_FED_FW_0000021969": "Upload Picture",
        "P_YS_PF_WORKBENCH-FE_0001133370": "Telephone Communication",
        "P_YS_PF_WORKBENCH-FE_0001133373": "Enterprise-level uniform basic file and data control",
        "P_YS_FED_IMP_IOT0000005567": "Confirm",
        "P_YS_PF_WORKBENCH-FE_0001133374": "Exit",
        "P_YS_OA_XTMENHU_0000046575": "Component Address",
        "P_YS_FED_EXAMP_0000020762": "Enterprise",
        "P_YS_PF_WORKBENCH-FE_0001133371": "View the records of your usage",
        "P_YS_OA_app_xtywlj_0000037365": "Ignore",
        "P_YS_PF_WORKBENCH-FE_0001133372": "I am a research and development engineer.",
        "P_YS_PF_PRINT_0000072986": "No related content",
        "P_YS_PF_GUIDE_0001071542": "It must be a picture",
        "P_YS_PF_YS-LOGIN_0001079584": "You clicked this icon; parameter called:",
        "P_YS_PF_WORKBENCH-FE_0001233069": "You can switch menus here",
        "P_YS_PF_WORKBENCH-FE_0001233068": "Switch Tenant",
        "P_YS_FED_UCFBASEDOC_0000025165": "Add Group",
        "P_YS_FED_UCFBASEDOC_0000025164": "Drag the widgets below to the right",
        "P_YS_FED_UCFBASEDOC_0000025043": "Add Shortcut to Homepage",
        "P_YS_SD_SDMAF_0000137369": "Self-adaptive",
        "P_YS_PF_WORKBENCH-FE_0001133377": "Expert teams provide product solutions according to enterprise requirements",
        "country66": "Thailand",
        "P_YS_PF_WORKBENCH-FE_0001133378": "Hand over Team",
        "country65": "Singapore",
        "P_YS_PF_WORKBENCH-FE_0001133375": "Free Consultation",
        "P_YS_PF_WORKBENCH-FE_0001133376": "Enterprise-level App market provides all-round digital service entrance",
        "country63": "Philippines",
        "country62": "Indonesia",
        "country61": "Australia",
        "P_YS_PF_WORKBENCH-FE_0001133379": "Please enter menu name first",
        "country60": "Malaysia",
        "P_YS_PF_WORKBENCH-FE_0001133380": "Light Blue",
        "P_YS_PF_WORKBENCH-FE_0001133381": "Click OK to refresh the page. Continue?",
        "P_YS_PF_WORKBENCH-FE_0001196918": "Copyright ©2023",
        "P_YS_PF_WORKBENCH-FE_0001133384": "I am an HR manager.",
        "P_YS_PF_WORKBENCH-FE_0001133385": "Provide product deployment solutions, that you‘re free to choose the products you need",
        "P_YS_PF_WORKBENCH-FE_0001133382": "You need to switch to the corresponding enterprise to view details. Switch?",
        "P_YS_PF_WORKBENCH-FE_0001133383": "Management: visible to enterprise administrators by default. Can be authorized to other users",
        "P_YS_PF_YS-LOGIN_0001079475": "No data returned",
        "P_YS_PF_WORKBENCH-FE_0001245170": "\"Portal Mgmt\" was changed to \"Workbench Mgmt\", and the entry was moved from \"Collaboration\" to \"System Mgmt\"",
        "P_YS_FED_IMP_IOT_0000129791": "Function Name",
        "P_YS_FED_FW_0000020962": "Simpl. Chinese",
        "P_YS_PF_GZTTMP_0000079071": "Doc Time",
        "P_YS_FED_FW_0000020961": "Saved successfully",
        "P_YS_PF_WORKBENCH-FE_0001237311": "Multi-device Login Prompt",
        "P_YS_PF_WORKBENCH-FE_0001237312": "Enter service name",
        "P_YS_PF_WORKBENCH-FE_0001237313": "Log in and log out from other devices",
        "P_YS_PF_WORKBENCH-FE_0001237314": "Relevant result not found",
        "P_YS_PF_WORKBENCH-FE_0001237315": "Your account has logged in on another device or browser. Log in anyway?",
        "P_YS_PF_WORKBENCH-FE_0001237316": "Do not log in",
        "P_YS_PF_WORKBENCH-FE_0001237317": "Log in and keep in other devices",
        "P_YS_PF_MES-FE_0001269122": "Interface error",
        "P_YS_PF_WORKBENCH-FE_0001237318": "Your account has logged in on another device or browser. Continue to log in?",
        "P_YS_PF_WORKBENCH-FE_0001237319": "Login Prompt",
        "P_YS_HR_HRPXF_0000055966": "Please enter team name",
        "P_YS_PF_WORKBENCH-FE_0001133388": "Product modules can be deployed in your exclusive computer room, eliminating your security concerns",
        "P_YS_PF_MANAGER-FE_0001087904": "Forbid users to apply",
        "P_YS_PF_WORKBENCH-FE_0001133389": "Paid Consultation",
        "P_YS_PF_WORKBENCH-FE_0001133386": "PC Client",
        "P_YS_PF_WORKBENCH-FE_0001203344": "Close Others",
        "P_YS_PF_WORKBENCH-FE_0001133387": "After a team is dissolved, the Apps under the team will no longer be available, and the corresponding data will be deleted. Please confirm that the data has been backed up.",
        "P_YS_PF_WORKBENCH-FE_0001228620": "Enterprise Component",
        "P_YS_PF_WORKBENCH-FE_0001133391": "I‘m an entrepreneur.",
        "P_YS_PF_WORKBENCH-FE_0001133392": "Null",
        "P_YS_PF_WORKBENCH-FE_0001271682": "User research",
        "P_YS_PF_WORKBENCH-FE_0001133390": "Please search for the user to hand over to.",
        "P_YS_PF_WORKBENCH-FE_0001228613": "Mask Transparency",
        "P_YS_PF_WORKBENCH-FE_0001271683": "[Tips] Click here to use the user survey and look forward to your participation",
        "P_YS_PF_WORKBENCH-FE_0001133395": "You've not joined any enterprise",
        "P_YS_PF_WORKBENCH-FE_0001133396": "The page contains unsaved data. Clicking OK will re-open the page. Are you sure to continue?",
        "P_YS_FED_IMP_IOT0000005424": "Edit",
        "P_YS_FED_EXAMP_0000020660": "Me",
        "P_YS_PF_AUTHF_0000096113": "5 entries/Page",
        "P_YS_FED_FW_0000021948": "Category",
        "P_YS_PF_WORKBENCH-FE_0001133393": "Service Application",
        "P_YS_PF_WORKBENCH-FE_0001133394": "Pre-sales staff will get in touch with you to discuss your customization needs",
        "P_YS_FED_FW_0000177597": "Upgrade",
        "P_YS_HR_HRXCF_0000056202": "Email format error",
        "P_YS_OA_XTMENHUCMS_0000044985": "Component",
        "P_YS_FI_CM_0000029891": "Please enter verification code",
        "P_YS_PF_WORKBENCH-FE_0001133319": "Quit from Team",
        "P_YS_PF_WORKBENCH-FE_0001133317": "my work efficiency, and facilitates team communication and collaboration.",
        "P_YS_PF_WORKBENCH-FE_0001133438": "Yonyou Cloud improves",
        "P_YS_PF_WORKBENCH-FE_0001133318": "One-on-one solutions provided by expert teams",
        "P_YS_PF_WORKBENCH-FE_0001133439": "Portal of Menus",
        "P_YS_PF_YS-LOGIN_0001196671": "Beijing ICP Certificate No. 05007539-24",
        "P_YS_PF_GZTTMP_0000075890": "Mobile",
        "P_YS_PF_WORKBENCH-FE_0001133311": "Basic attendance and salary query services",
        "P_YS_PF_WORKBENCH-FE_0001133432": "I am an IT operation and maintenance manager.",
        "P_YS_FI_FCWEB_0001048519": "Recently used",
        "P_YS_OA_XTMENHU_0000046660": "Initiating Time:",
        "P_YS_PF_MANAGER-FE_0001087915": "Fill in Mobile Homepage or summerId. ",
        "P_YS_PF_WORKBENCH-FE_0001133312": "Customize",
        "P_YS_PF_WORKBENCH-FE_0001133433": "You've not purchased any service",
        "P_YS_OA_XTMENHU_0000046780": "No approval task",
        "P_YS_PF_WORKBENCH-FE_0001133430": "Add to Homepage",
        "P_YS_PF_WORKBENCH-FE_0001133310": "Address: Yonyou Industry Park, No.68 Beiqing Road, Haidian District, Beijing",
        "P_YS_PF_WORKBENCH-FE_0001133431": "Missing required parameter: serviceCode",
        "P_YS_OA_XTMENHU_0000046540": "Text Mode",
        "P_YS_PF_MANAGER-FE_0001087912": "Runtime Env. Ver",
        "P_YS_PF_WORKBENCH-FE_0001133315": "History",
        "P_YS_PF_WORKBENCH-FE_0001133436": "Loading mdf",
        "P_YS_PF_WORKBENCH-FE_0001133316": "The HR shared services of Yonyou Cloud",
        "P_YS_PF_WORKBENCH-FE_0001133437": "Expert Team On-site Services",
        "P_YS_PF_WORKBENCH-FE_0001133313": "Do not switch",
        "P_YS_PF_WORKBENCH-FE_0001133434": "Intelligent IM",
        "P_YS_PF_WORKBENCH-FE_0001133314": "Scan to Download Client",
        "P_YS_PF_WORKBENCH-FE_0001133435": "Upgrading to enterprise…",
        "P_YS_PF_GZTSYS_0000012336": "Open Platform",
        "P_YS_PF_WORKBENCH-FE_0001274545": "No new members",
        "P_YS_PF_GZTSYS_0000015967": "Settings",
        "P_YS_PF_WORKBENCH-FE_0001274544": "Unknown department",
        "P_YS_PF_WORKBENCH-FE_0001274543": "Please enter the component link",
        "P_YS_OA_XTTMCENTER_0000035088": "Yonyou's Official Website",
        "P_YS_PF_WORKBENCH-FE_0001274542": "快捷應用",
        "P_YS_SD_SDMB_0000146914": "Beijing Headquarters",
        "P_YS_PF_MANAGER-FE_0001087908": "Confirm to remove the selected user?",
        "P_YS_PF_WORKBENCH-FE_0001133440": "Dissolve Team",
        "P_YS_OA_XTMENHU_0000046542": "Template Selection",
        "P_YS_IPAAS_UCG_0001063993": "Water, Environment and Public Facilities Management Industry",
        "P_YS_IPAAS_UCG_0001063994": "Info Transmission, Computer Service and Software Industry",
        "P_YS_FED_FW_0000021994": "Set as Default",
        "P_YS_FED_EXAMP_0000020713": "Mobile No.",
        "P_YS_PF_WORKBENCH-FE_0001274549": "Content name",
        "P_YS_OA_LCGL_0000037233": "User Name",
        "P_YS_PF_WORKBENCH-FE_0001274548": "Earliest by submission time",
        "P_YS_FED_UCFBASEDOC_0000025257": "Search...",
        "P_YS_FED_FW_0000021874": "Type",
        "P_YS_PF_WORKBENCH-FE_0001274547": "Document type/submission time",
        "P_YS_PF_WORKBENCH-FE_0001274546": "Maximum number of displays",
        "P_YS_FED_UCFBASEDOC_0000025253": "Sign Up",
        "P_YS_PF_MANAGER-FE_0001087800": "Remove",
        "P_YS_PF_WORKBENCH-FE_0001133328": "Elegant Grey",
        "P_YS_PF_WORKBENCH-FE_0001133449": "Hide",
        "P_YS_PF_MANAGER-FE_0001087920": "Free of Login",
        "P_YS_PF_WORKBENCH-FE_0001133329": "Expand",
        "P_YS_FED_UCFBASEDOC_0000025251": "Please enter mobile number",
        "P_YS_PF_MANAGER-FE_0001087806": "In New Browser Page",
        "P_YS_PF_WORKBENCH-FE_0001133322": "Stricter enterprise member management",
        "P_YS_PF_WORKBENCH-FE_0001133443": "Click Discard and your editing will be discarded",
        "P_YS_PF_MANAGER-FE_0001087926": "Upload Local Icon",
        "P_YS_PF_WORKBENCH-FE_0001133323": "Member Permission",
        "P_YS_PF_WORKBENCH-FE_0001133444": "At the end of each month and each year, we always have to work overtime on various financial statements.",
        "P_YS_PF_WORKBENCH-FE_0001133320": "I am a financial manager",
        "P_YS_PF_WORKBENCH-FE_0001133441": "Enter your personal information so that we can get in touch with you",
        "P_YS_PF_MANAGER-FE_0001087807": "Allow Users to Log Out ",
        "P_YS_PF_WORKBENCH-FE_0001133321": "Business: by role authorization only",
        "P_YS_PF_WORKBENCH-FE_0001133442": "Return to Homepage",
        "P_YS_PF_MANAGER-FE_0001087923": "Web",
        "P_YS_PF_WORKBENCH-FE_0001133326": "Switch Enterprise",
        "P_YS_PF_WORKBENCH-FE_0001133447": "Removed successfully",
        "P_YS_PF_MANAGER-FE_0001087922": "Please enter service name.",
        "P_YS_PF_WORKBENCH-FE_0001133327": "Hotline: 010-62438888",
        "P_YS_PF_WORKBENCH-FE_0001133448": "Homepage",
        "P_YS_PF_MANAGER-FE_0001087925": "Icon size: 120*120; format: JPG, GIF or PNG; no more than 5M",
        "P_YS_PF_MANAGER-FE_0001087804": "Service name cannot be more than 6 Chinese chars or 12 letters.",
        "P_YS_PF_WORKBENCH-FE_0001133324": "Group name; no more than 12 chars",
        "P_YS_PF_WORKBENCH-FE_0001133445": "Could not access Help Center from your network. Please switch to Internet and try again.",
        "P_YS_PF_WORKBENCH-FE_0001133325": "Loading data...",
        "P_YS_PF_WORKBENCH-FE_0001133446": "You can find all the functions here.",
        "P_YS_PF_GZTSYS_0000012589": "Approval",
        "P_YS_FED_EXAMP_0000020600": "Yes",
        "P_YS_PF_WORKBENCH-FE_0001133450": "Photo",
        "P_YS_PF_WORKBENCH-FE_0001133330": "Role-based application permission management",
        "P_YS_PF_WORKBENCH-FE_0001133451": "Confirm to remove the selected user?",
        "P_YS_OA_XTMENHU_0000046775": "Select Friends",
        "P_YS_FI_FCWEB_0001047535": "Full?Screen",
        "P_YS_OA_XTMENHU_0000046539": "Birthday Wishes",
        "P_YS_OA_LCGL_0000037221": "User Code",
        "P_YS_PF_MANAGER-FE_0001087811": ">2000",
        "P_YS_PF_WORKBENCH-FE_0001133339": "After upgrading to an enterprise, you will get more privileges",
        "P_YS_FED_UCFBASEDOC_0000025483": "Added",
        "P_YS_HR_HRJXF_0000059541": "Verification failed",
        "P_YS_PF_WORKBENCH-FE_0001220704": "Moments",
        "P_YS_PF_GZTSYS_0000109035": "Favorites",
        "P_YS_PF_MANAGER-FE_0001087817": "Please enter enterprise address.",
        "P_YS_PF_WORKBENCH-FE_0001133333": "Send the link to your friends",
        "P_YS_PF_WORKBENCH-FE_0001133454": "On-site Demonstration",
        "P_YS_PF_MANAGER-FE_0001087937": "Please choose scale",
        "P_YS_PF_WORKBENCH-FE_0001133334": "Profile",
        "P_YS_PF_WORKBENCH-FE_0001133331": "Close All Pages",
        "P_YS_PF_WORKBENCH-FE_0001133452": " Apps will expire soon. ",
        "P_YS_PF_GZTPRE_0000071076": "Owning Application",
        "P_YS_PF_WORKBENCH-FE_0001133332": "Upgrade to Enterprise",
        "P_YS_PF_WORKBENCH-FE_0001133453": "Running the business no longer makes me anxious.",
        "P_YS_PF_WORKBENCH-FE_0001133337": "Morandi Yellow",
        "P_YS_PF_MANAGER-FE_0001087933": "Invite by Admin",
        "P_YS_PF_WORKBENCH-FE_0001133338": "Your enterprise has ",
        "P_YS_SD_UDHWS_0000070064": "Enterprise Name",
        "P_YS_PF_WORKBENCH-FE_0001133335": "Renew",
        "P_YS_PF_MANAGER-FE_0001087814": "Use App Navigation",
        "P_YS_PF_WORKBENCH-FE_0001133336": "Please enter graphic verification code",
        "P_YS_OA_XTMENHU_0000046569": "Notifications",
        "P_YS_PF_GZTSYS_0000012679": "Manager Self-services",
        "P_YS_PF_WORKBENCH-FE_0001133340": "Team App",
        "P_YS_OA_XTMENHU_0000046686": "Submitted By:",
        "P_YS_PF_MANAGER-FE_0001087809": "Macau Special Administrative Region of China",
        "P_YS_PF_WORKBENCH-FE_0001133341": "According to your needs, we can provide expert team on-site solutions",
        "P_YS_FED_IMP_IOT0000005514": "Next",
        "P_YS_IPAAS_UCG_0001063976": "Mining Industry",
        "P_YS_FED_FW_0000021612": "Failed to load",
        "P_YS_HR_HRXCF_0000072788": "Please select data source",
        "P_YS_FED_FW_0000021852": "Refresh",
        "P_YS_FED_EXAMP_0000020736": "Hide",
        "P_YS_PF_MANAGER-FE_0001087820": "1001-2000",
        "P_YS_PF_MANAGER-FE_0001087941": "After quitting from an enterprise, the Apps under the enterprise will no longer be available, and the corresponding data will be deleted. Please confirm that the data has been backed up.",
        "P_YS_SD_SDMAF_0000137211": "Restore Default Settings",
        "P_YS_PF_MANAGER-FE_0001087943": "Wrong mobile No. format",
        "P_YS_OA_XTRIZHI_0000036826": "Favorites",
        "P_YS_PF_WORKBENCH-FE_0001133344": "Hotline: 010-62438888",
        "P_YS_PF_MANAGER-FE_0001087827": "Native App",
        "P_YS_PF_WORKBENCH-FE_0001133345": "Service Process",
        "P_YS_PF_WORKBENCH-FE_0001133342": "Yonyou Cloud enables us to track the company‘s financial data in real-time every day, really making finance a part of the business.",
        "P_YS_FI_CM_0000026177": "Approved",
        "P_YS_PF_MANAGER-FE_0001087829": "App Native Navigation",
        "P_YS_PF_WORKBENCH-FE_0001133343": "Service icon",
        "P_YS_PF_MANAGER-FE_0001087945": "Enter the redirect URL from YouZone PC version",
        "P_YS_PF_WORKBENCH-FE_0001133348": "Enterprise-level Org structure management",
        "P_YS_PF_MANAGER-FE_0001087823": "Select default icon",
        "P_YS_PF_WORKBENCH-FE_0001133349": "Please enter graphic verification code",
        "P_YS_PF_WORKBENCH-FE_0001133346": "Log Out",
        "P_YS_PF_WORKBENCH-FE_0001133347": "Menu Path",
        "P_YS_PF_GZTSYS_0001010812": "Enterprise Certification",
        "P_YS_OA_XTMENHU_0000046557": "Unread",
        "P_YS_PF_WORKBENCH-FE_0001133351": "Confirm to set the current user as an administrator?",
        "P_YS_OA_XTMENHU_0000046675": "Greetings",
        "P_YS_PF_WORKBENCH-FE_0001133352": "My Portal",
        "P_YS_PF_PRINT_0000106816": "Middle",
        "P_YS_OA_XTMENHU_0000046556": "Please enter the network address of the custom component",
        "P_YS_PF_WORKBENCH-FE_0001133350": "Yonyou Group",
        "P_YS_FED_UCFBASEDOC_0000025589": "Published successfully",
        "P_YS_FED_UCFBASEDOC_0000025345": "Move to",
        "P_YS_SD_SDMBF_0000141689": "Expiration time:",
        "OA_web_statistics_000000106": "Product Name",
        "P_YS_PF_WORKBENCH-FE_0001208723": "Zoom In",
        "P_YS_PF_WORKBENCH-FE_0001228574": "You Secretary",
        "P_YS_PF_WORKBENCH-FE_0001208722": "Extra Large",
        "P_YS_SD_SDMAUF_0000153108": "Customer Service",
        "P_YS_OA_XTTMCENTER_0000035047": "YouZone",
        "P_YS_OA_XTMENHUCMS_0000045340": "Top",
        "P_YS_OA_XTTMCENTER_0000035043": "Link",
        "P_YS_FED_EXAMP_0000019931": "Mailbox",
        "P_YS_IPAAS_UCG_0001064402": "Real Estate Industry",
        "P_YS_SD_SDMBF_0000144965": "Display Method",
        "P_YS_PF_GZTSYS_0000012812": "To-dos",
        "P_YS_OA_XTMENHUCMS_0000045344": "IOS Redirection Parameter",
        "P_YS_PF_GZTSYS_0000012814": "Team",
        "P_YS_SD_SDMBF_0000142527": "Please click.",
        "P_YS_HR_HRJQ_0000031105": "Unprocessed",
        "P_YS_FED_EXAMP_0000019939": "OK",
        "P_YS_PF_WORKBENCH-FE_0001228566": "Ad Details",
        "P_YS_PF_WORKBENCH-FE_0001228565": "Digital Contents",
        "P_YS_OA_XTTMCENTER_0000035058": "Yonyou Cloud Official Website",
        "P_YS_IPAAS_UCG_0001064652": "Manufacturing",
        "P_YS_PF_WORKBENCH-FE_0001274451": "sed execution error",
        "P_YS_PF_WORKBENCH-FE_0001274450": "Temporary folder location",
        "P_YS_IPAAS_UCG_0001064416": "Environment and Public Administration, Social Insurance, and Social Org",
        "P_YS_FED_FW_0000022192": "Move Up",
        "P_YS_PF_WORKBENCH-FE_0001228592": "Large",
        "000357": "Delete Files",
        "P_YS_FED_FW_0000022197": "Expand",
        "P_YS_PF_WORKBENCH-FE_0001228597": "Confirm to restore the default settings?",
        "P_YS_PF_WORKBENCH-FE_0001228599": "Edit Card",
        "P_YS_PF_WORKBENCH-FE_0001228598": "Restoration Prompt",
        "P_YS_OA_LCSJ_0001130313": "Before",
        "P_YS_OA_XTTMCENTER_0000035064": "Download",
        "P_YS_FED_EXAMP_0000019832": ", ",
        "P_YS_OA_XTTMCENTER_0000035062": "Download Client",
        "P_YS_FI_IA_0000054929": "Doc Type",
        "P_YS_PF_WORKBENCH-FE_0001274449": "Delete directory",
        "P_YS_PF_WORKBENCH-FE_0001274448": "Capturing multilingual addresses",
        "P_YS_HR_HRYGF_0000058823": "Upgrade",
        "P_YS_PF_WORKBENCH-FE_0001243713": "Function Guide",
        "P_YS_PF_MANAGER-FE_0001116216": "Visible to All Staff",
        "P_YS_PF_METADATA_0000087187": "Field",
        "P_YS_PF_METADATA_0000086098": "User Info",
        "P_YS_PF_WORKBENCH-FE_0001228589": "Card Property Settings",
        "P_YS_PF_WORKBENCH-FE_0001274556": "Call failed, DomID:",
        "P_YS_PF_WORKBENCH-FE_0001274555": "Rendering function for tiles",
        "P_YS_PF_WORKBENCH-FE_0001274554": "According to the latest submission time",
        "P_YS_PF_WORKBENCH-FE_0001274553": "Attribute rendering of tile failed\"",
        "P_YS_PF_AUTHF_0000096078": "20 /page",
        "P_YS_PF_WORKBENCH-FE_0001274552": "Please enter the maximum display quantity",
        "P_YS_PF_WORKBENCH-FE_0001274551": "Please enter the requested address",
        "P_YS_IPAAS_UCG_0001064631": "Scientific Research, Technical Services and Geological Prospecting",
        "P_YS_PF_WORKBENCH-FE_0001274550": "By document type",
        "P_YS_PF_WORKBENCH-FE_0001238259": "To-do Notice",
        "P_YS_PF_WORKBENCH-FE_0001274558": "Interface return format",
        "P_YS_OA_XTMENHUCMS_0000045311": "Approval Center",
        "P_YS_PF_WORKBENCH-FE_0001274557": "Please enter content name",
        "P_YS_PF_SOCD-S_0000183662": "Enterprise Mgmt",
        "P_YS_PF_WORKBENCH-FE_0001133399": "After handing over a team, you'll no longer have the administrator permissions.",
        "P_YS_PF_WORKBENCH-FE_0001133397": "Link copied. Send it to your friends now!",
        "P_YS_PF_WORKBENCH-FE_0001133398": "Digital Portal",
        "country84": "Vietnam",
        "P_YS_SD_UDHMC_0000050938": "Skip",
        "P_YS_OA_XTTMCENTER_0000035122": "Administrator",
        "P_YS_OA_XTMENHUCMS_0000045143": "Favorite Apps",
        "P_YS_SD_UDHWN_0000121225": "Last Month",
        "P_YS_OA_XTMENHUCMS_0000045382": "Android Download Link",
        "P_YS_IPAAS_UCG_0001064325": "Construction Industry",
        "P_YS_SD_SDMA_0000060355": "Help Center",
        "P_YS_IPAAS_UCG_0001064207": "Resident Services and Other Services",
        "P_YS_PF_GZTSYS_0000011889": "Honor",
        "P_YS_FI_CM_0000029021": "Go to ",
        "P_YS_HR_HRJQ_0000031143": "None",
        "P_YS_FED_UCFBASEDOC_0000025096": "Confirm to delete the service?",
        "country95": "Burma",
        "P_YS_OA_XTTXL_0000045969": "Message",
        "P_YS_OA_XTMENHUCMS_0000045376": "Server Address",
        "P_YS_IPAAS_UCG_0001064571": "Leasing and Business Services",
        "P_YS_OA_XTMENHUCMS_0000045375": "Mobile Version Homepage",
        "P_YS_FED_FW_0000021923": "OK",
        "P_YS_PF_GZTSYS_0000012860": "Dynamic",
        "P_YS_SD_UDHWN_0000120386": "Apply Now",
        "P_YS_IPAAS_UCG_0001064578": "Finance and Insurance Industries",
        "P_YS_PF_GZTSYS_0000012505": "Basic Settings",
        "P_YS_IPAAS_UCG_0001009417": "DingTalk",
        "P_YS_FI_CM_0000030025": "Expiration Time",
        "P_YS_FED_EXAMP_0000019906": "More",
        "P_YS_PF_WORKBENCH-FE_0001217140": "Please select at least one client",
        "P_YS_OA_XTMENHUCMS_0000045362": "Android Redirection Parameter",
        "P_YS_OA_XTTMCENTER_0000035140": "Quit",
        "P_YS_HR_HRJQ_0000031030": "Null",
        "P_YS_PF_WORKBENCH-FE_0001232883": "Switch to New Version",
        "P_YS_OA_XTMENHUCMS_0000045366": "In Current Page",
        "P_YS_PF_WORKBENCH-FE_0001232882": "My Workbench",
        "P_YS_FED_UCFBASEDOC_0000025079": "Failed to publish",
        "P_YS_SCM_PU_0000028707": "Merchant",
        "P_YS_SD_UDHWN_0000122693": "Last Week",
        "P_YS_OA_XTMENHUCMS_0000045353": "IOS Download Link",
        "P_YS_OA_XTMENHUCMS_0000045352": "Publish Client",
        "P_YS_OA_XTTMCENTER_0000035034": "Contact Us",
        "P_YS_PF_GZTSYS_0000011990": "Portal Homepage",
        "P_YS_HR_HRRCPDF_0000071186": "Yonyou Network Tech Co., Ltd.",
        "P_YS_OA_XTMENHUCMS_0000045359": "In New Page",
        "P_YS_HR_HRPXF_0000056053": "Team Name",
        "P_YS_PF_WORKBENCH-FE_0001229381": "Select Widget",
        "P_YS_PF_MANAGER-FE_0001087797": "Allow all users to apply",
        "P_YS_PF_WORKBENCH-FE_0001229380": "Sort by Dragging",
        "P_YS_PF_MANAGER-FE_0001087794": "Name, Mobile No., E-mail Address",
        "P_YS_PF_WORKBENCH-FE_0001229385": "The recommended value should be an integer multiple of 87",
        "P_YS_PF_MANAGER-FE_0001087793": "Display Watermark in Contacts",
        "P_YS_PF_WORKBENCH-FE_0001229384": "User-defined Height",
        "P_YS_PF_MANAGER-FE_0001087796": "PC Client",
        "P_YS_OA_XTLCZX_0000030256": "CC",
        "P_YS_PF_WORKBENCH-FE_0001229383": "Content Settings",
        "P_YS_PF_MANAGER-FE_0001087795": "Based on imported reporting relationship",
        "P_YS_PF_WORKBENCH-FE_0001229382": "Rich Text Content Settings",
        "P_YS_PF_WORKBENCH-FE_0001229388": "Display Name",
        "P_YS_SD_SDMAF_0001008026": "Created successfully.",
        "P_YS_PF_WORKBENCH-FE_0001229387": "Display Notification",
        "P_YS_PF_WORKBENCH-FE_0001229386": "Component Height",
        "P_YS_PF_GZTSYS_0000013194": "Workbench",
        "P_YS_PF_GZTSYS_0001025942": "Portal Ads Space",
        "P_YS_IPAAS_UCG_0001064361": "Agriculture Forestry Animal Husbandry and Fishery Industries",
        "P_YS_OA_XTTXL_0000045990": "Management",
        "P_YS_FED_UCFBASEDOC_0000025619": "Add Folder",
        "P_YS_IPAAS_UCG_0001064369": "International Organization",
        "P_YS_FED_IMP_IOT0000008165": "Delete",
        "P_YS_FED_UCFBASEDOC_0000025614": "Mobile Phone",
        "P_YS_IPAAS_UCG_0001064009": "Accommodation and Catering Industry",
        "P_YS_FED_FW_0000022366": "Modified successfully",
        "P_YS_PF_WORKBENCH-FE_0001229374": "Ads space resources can be set in Portal Ads Space",
        "P_YS_PF_WORKBENCH-FE_0001229373": "Set the picture carousel interval when there are multiple ads pictures",
        "P_YS_PF_WORKBENCH-FE_0001229377": "Enable Customization",
        "P_YS_PF_WORKBENCH-FE_0001229376": "Associated Ads",
        "P_YS_PF_WORKBENCH-FE_0001229375": "Picture Carousel Interval",
        "P_YS_IPAAS_UCG_0001064490": "Culture, Sports and Recreation",
        "P_YS_PF_WORKBENCH-FE_0001229379": "Search App Name",
        "P_YS_IPAAS_UCG_0001064251": "Health, Social Security and Social Service Industry",
        "P_YS_OA_XTMENHUCMS_0000045298": "Picture Style",
        "P_YS_OA_XTMENHUCMS_0000045174": "Ads Space",
        "P_YS_IPAAS_UCG_0001064138": "Electricity/Heating Power/Gas/Water Production and Supply Industry",
        "P_YS_FED_UCFBASEDOC_0000024755": "Delete",
        "P_YS_FED_UCFBASEDOC_0000025601": "Please enter e-mail",
        "P_YS_FED_UCFBASEDOC_0000024752": "Confirm to delete the service?",
        "P_YS_FED_UCFBASEDOC_0000024870": "View Details",
        "P_YS_PF_AUTHF_0000080113": "10 /page",
        "P_YS_FED_FW_0000021020": "New",
        "P_YS_OA_XTMENHUCMS_0000045290": "Background Color",
        "P_YS_SD_SDMAUF_0000152315": "After",
        "P_YS_OA_XTMENHUCMS_0000045287": "Favorite Apps",
        "P_YS_OA_XTMENHUCMS_0000045284": "Icon Size",
        "P_YS_OA_XTMENHUCMS_0000045041": "Component Name",
        "P_YS_FED_UCFBASEDOC_0000024748": "Confirm to batch delete?",
        "P_YS_PF_GZTLOG_0000080270": "Web",
        "P_YS_FED_UCFBASEDOC_0000024866": "Save the latest modification?",
        "P_YS_FED_FW_0000022466": "Default",
        "P_YS_FED_FW_0000021376": "China",
        "P_YS_OA_XTSPZX_0000034639": "Field",
        "P_YS_FED_FW_0000021379": "Beijing",
        "P_YS_FED_UCFBASEDOC_0000024982": "Discard",
        "P_YS_OA_XTMENHUCMS_0000045168": "Message Center",
        "P_YS_SCM_STOCK_0000034455": "Unread",
        "P_YS_PF_WORKBENCH-FE_0001241019": "Workbench",
        "P_YS_OA_XTTMCENTER_0000035108": "Yonyou Cloud Market",
        "P_YS_PF_MANAGER-FE_0001120439": "Wrong parameter: applicationId",
        "P_YS_PF_GZTLOG_0000025976": "Lock",
        "P_YS_FED_FW_0000022475": "Industry",
        "P_YS_SD_SDMBF_0000144334": "Please upload picture",
        "P_YS_OA_XTMENHUCMS_0000045158": "Work Portal",
        "P_YS_FI_CM_0000029097": "Today",
        "P_YS_FI_FA_0000056249": "Add Cards",
        "P_YS_FED_EXAMP_0000020397": "Name",
        "P_YS_FED_FW_0000022168": "Please enter keywords",
        "P_YS_PF_AUTHF_0000080120": "15 /page",
        "P_YS_OA_XTLCZX_0000030221": "System",
        "P_YS_FED_FW_0000022064": "No data",
        "P_YS_IPAAS_UCG_0001064293": "Wholesale and Retail Trade",
        "P_YS_PF_WORKBENCH-FE_0001202943": "Fixed Navigation",
        "P_YS_PF_WORKBENCH-FE_0001202944": "Lock Menu",
        "P_YS_PF_WORKBENCH-FE_0001202945": "Switch Navigation",
        "P_YS_PF_WORKBENCH-FE_0001202946": "Unfix",
        "P_YS_PF_WORKBENCH-FE_0001202941": "Quick Navigation",
        "P_YS_PF_WORKBENCH-FE_0001202942": "Global Navigation",
        "country886": "Taiwan, China",
        "P_YS_FI_FCWEB_0001048065": "Workbench setting",
        "P_YS_PF_GZTSYS_0000011939": "My Portal",
        "P_YS_SD_SDMB_0000146348": "Service Support",
        "P_YS_FED_FW_0000022179": "Alignment",
        "P_YS_PF_WORKBENCH-FE_0001202947": "Quick Navigation Settings",
        "P_YS_FED_UCFBASEDOC_0000024951": "The groups without content are invisible on the homepage",
        "P_YS_OA_XTLCZX_0000030219": "Search Result",
        "P_YS_PF_GZTSYS_0000012902": "Others",
        "P_YS_SD_SDMAUF_0000152873": "History",
        "P_YS_PF_PROCENTER_0000022591": "Verification failed",
        "P_YS_PF_WORKBENCH-FE_0001212762": "Quick Search",
        "P_YS_SCM_STOCK_0000034523": "Read",
        "P_YS_SD_SDMAUF_0000152518": "Remaining",
        "P_YS_FED_EXAMP_0000020183": "Close",
        "P_YS_PF_WORKBENCH-FE_0001153504": "No Longer Remind",
        "P_YS_PF_WORKBENCH-FE_0001137268": "Ignored. Do not remind again",
        "P_YS_FED_UCFBASEDOC_0000024820": "To",
        "P_YS_FED_UCFBASEDOC_0000024942": "Add",
        "P_YS_OA_app_xtyyjm_0000035755": "Pending Approval",
        "P_YS_OA_XTLCZX_0000030480": "Small",
        "P_YS_FED_UCFBASEDOC_0000024938": "Delete Service",
        "P_YS_FED_UCFBASEDOC_0000024930": "Please enter contact name",
        "P_YS_OA_XTLCZX_0000030238": "Background Picture",
        "P_YS_OA_app_xtyyjm_0000035750": "Members",
        "P_YS_PF_WORKBENCH-FE_0001212760": "” related result not found. Please re-enter",
        "P_YS_PF_WORKBENCH-FE_0001212761": "Failed to search for“",
        "P_YS_PF_WORKBENCH-FE_0001233364": "Enhanced Personalization Capabilities of Workbench",
        "P_YS_SD_SDMB_0000139191": "Message Details",
        "P_YS_PF_WORKBENCH-FE_0001233363": "Support more widgets, more flexible layout, and richer display effects",
        "P_YS_PF_WORKBENCH-FE_0001233362": "Portals have been consolidated into workbenches, enabling users to switch between multiple workbenches; the role-based workbenches can help you better complete your work",
        "P_YS_PF_MANAGER-FE_0001087832": "Allow to Apply",
        "P_YS_PF_WORKBENCH-FE_0001233361": "Enterprise Account Relocated",
        "P_YS_FED_UCFBASEDOC_0000025581": "Rename",
        "P_YS_PF_WORKBENCH-FE_0001233360": "Upgraded Digital Portal",
        "P_YS_OA_XTMENHUCMS_0000044935": "Posts",
        "P_YS_PF_GZTSYS_0000109255": "Failed to get Verif. code",
        "P_YS_PLM_BASE-FE_0001160596": "Top",
        "P_YS_OA_XTMENHUCMS_0000044934": "Long Ads Space",
        "P_YS_OA_YBMOB_0000036991": "Approval Details",
        "P_YS_SD_SDMA_0000123136": "Homepage",
        "P_YS_PF_MANAGER-FE_0001087834": "Enter the redirect URL from YouZone mobile version",
        "P_YS_PF_MANAGER-FE_0001087957": "Please enter Android download link",
        "P_YS_PF_MANAGER-FE_0001087836": "Please enter IOS download link",
        "P_YS_FED_EXAMP_0000020115": "Switch",
        "P_YS_FED_EXAMP_0000020236": "Copy Link",
        "P_YS_OA_XTMENHU_0000046746": "Alerts",
        "P_YS_OA_XTMENHU_0000046620": "Link Name",
        "P_YS_SD_UDHMC_0000051143": "Please enter enterprise name",
        "P_YS_PF_WORKBENCH-FE_0001233359": "Optimized Menu Navigation",
        "P_YS_PF_WORKBENCH-FE_0001233358": "Enterprise Account has been moved to the user drop-down panel",
        "P_YS_FED_UCFBASEDOC_0000025215": "Log In",
        "P_YS_PF_WORKBENCH-FE_0001233357": "More powerful workbench configuration capabilities and more efficient menu navigation",
        "P_YS_PF_WORKBENCH-FE_0001233356": "Support Multi-workbench",
        "P_YS_PF_WORKBENCH-FE_0001233355": "Brand new menu panel with the new search function, supporting quickly adding into Favorites and viewing recently used services",
        "P_YS_OA_app_xtywlj_0000037879": "Category",
        "P_YS_PF_MANAGER-FE_0001087842": "Redirection Parameters",
        "P_YS_PF_WORKBENCH-FE_0001133407": "All History",
        "P_YS_PF_MANAGER-FE_0001087841": "Invite All",
        "P_YS_PF_WORKBENCH-FE_0001133408": "Yonyou Cloud, a completely publicized enterprise cloud service, frees me from the traditional operation and maintenance work, so that I can become a builder of the company‘s data assets.",
        "P_YS_PF_MANAGER-FE_0001087844": "Please select if it is a native App",
        "P_YS_PF_WORKBENCH-FE_0001133405": "Start Recording",
        "P_YS_PF_MANAGER-FE_0001087964": "PC Client Homepage",
        "P_YS_PF_MANAGER-FE_0001087843": "Enter the installation pack ID to upload to iuap",
        "P_YS_PF_WORKBENCH-FE_0001133406": "Person, service, or others",
        "P_YS_OA_XTWEIYOU_0000046270": "Send E-mail at the same time",
        "P_YS_FED_FW_0000055346": "Please select data",
        "P_YS_PF_MANAGER-FE_0001087840": "Web Homepage",
        "P_YS_PF_MANAGER-FE_0001087961": "Favorite App",
        "P_YS_PF_WORKBENCH-FE_0001133409": "Remove from Home",
        "P_YS_PF_WORKBENCH-FE_0001133400": " Apps have expired. ",
        "P_YS_FI_CM_0000029500": " ",
        "P_YS_PF_MANAGER-FE_0001087846": "Offline App",
        "P_YS_PF_WORKBENCH-FE_0001133403": "Team Settings",
        "P_YS_PF_MANAGER-FE_0001087966": "Display Supr./Sub.",
        "P_YS_PF_WORKBENCH-FE_0001133404": "free me from tedious and repetitive routine tasks.",
        "P_YS_PF_MANAGER-FE_0001087848": "Invitation Rules",
        "P_YS_PF_WORKBENCH-FE_0001133401": "Background Color",
        "P_YS_PF_MANAGER-FE_0001087847": "Enter the redirect URL from a Web browser",
        "P_YS_PF_WORKBENCH-FE_0001133402": "More Results",
        "P_YS_FED_EXAMP_0000020005": "Template",
        "P_YS_PF_WORKBENCH-FE_0001242095": "Not yet added to favorites. Add now",
        "P_YS_PF_WORKBENCH-FE_0001242096": "Don't know",
        "P_YS_PF_GZTSYS_0000013477": "Save",
        "P_YS_PF_METADATA_0000084364": "Request Address",
        "P_YS_PF_GZTSYS_0000015896": "Team Member",
        "P_YS_FI_CM_0000028899": "Log Out",
        "P_YS_OA_XTLCZX_0000030776": "Normal",
        "P_YS_FED_UCFBASEDOC_0000025203": "Get Verification Code",
        "P_YS_PF_WORKBENCH-FE_0001233465": "Start",
        "P_YS_OA_XTMENHU_0000046739": "My Tasks",
        "P_YS_OA_XTMENHU_0000046618": "My Project",
        "P_YS_FED_UCFBASEDOC_0000025200": "Mobile",
        "P_YS_OA_XTNEIBUQUN_0000046122": "Set Administrator",
        "P_YS_PF_WORKBENCH-FE_0001133418": "Maintaining the company‘s hundreds of servers every day makes me really anxious, may affect the company‘s business development.",
        "P_YS_PF_MANAGER-FE_0001087852": "Please upload the Service icon.",
        "P_YS_PF_WORKBENCH-FE_0001133419": "Fill in Information",
        "P_YS_HR_HRSBF_0001183870": "Personal Settings",
        "P_YS_PF_WORKBENCH-FE_0001133416": "Publish to Menu",
        "P_YS_PF_WORKBENCH-FE_0001133417": "Email: diwork@yonyou.com",
        "P_YS_OA_XTLCZX_0000030555": "Tile",
        "P_YS_PF_WORKBENCH-FE_0001232171": "Remaining Qty",
        "P_YS_PF_WORKBENCH-FE_0001232170": "Earlier",
        "P_YS_PF_WORKBENCH-FE_0001133410": "Trust us, and start digital working right away",
        "P_YS_PF_WORKBENCH-FE_0001133411": "Stop Recording",
        "P_YS_PF_WORKBENCH-FE_0001133414": " ",
        "P_YS_PF_WORKBENCH-FE_0001133415": "The current tenant has turned on the login control policy. The control mode is Verification Code",
        "P_YS_PF_WORKBENCH-FE_0001133412": "Account Mgmt",
        "P_YS_OA_YBMOB_0000036890": "File",
        "P_YS_PF_MANAGER-FE_0001087858": "Priority at Top",
        "P_YS_PF_WORKBENCH-FE_0001133413": "If you want to buy or know more about the product, please call the hotline:",
        "P_YS_FED_EXAMP_0000020016": "Homepage",
        "P_YS_OA_XTMENHU_0000046646": "Invitation Link",
        "P_YS_SD_SDMA_0000098308": "Page Settings",
        "P_YS_OA_XTMENHU_0000046524": "To-dos",
        "P_YS_PF_WORKBENCH-FE_0001245211": "Left-Right",
        "P_YS_PF_GZTSYS_0000013325": "Label",
        "P_YS_OA_XTMENHU_0000046644": "Space Management",
        "P_YS_OA_XTMENHU_0000046523": "Graphic Mode",
        "P_YS_FED_UCFBASEDOC_0000025319": "Verification Code",
        "P_YS_PF_METADATA_0000085782": "Product Code",
        "P_YS_HR_HRJQF_0000054364": "Import finished",
        "P_YS_OA_app_xtyyjm_0000035782": "Select Report",
        "P_YS_PF_WORKBENCH-FE_0001232168": "Exception in obtaining the data. Please refresh",
        "P_YS_OA_app_xtywlj_0000037618": "Business",
        "P_YS_PF_WORKBENCH-FE_0001232169": "Authorization Usage",
        "P_YS_PF_WORKBENCH-FE_0001232166": "Authorization Status Details",
        "P_YS_PF_WORKBENCH-FE_0001232167": "No. of Authorizations",
        "P_YS_HR_HRCOREF_0000058092": "Current Person Qty",
        "P_YS_PF_WORKBENCH-FE_0001133429": "Scan QR code to enter the",
        "P_YS_PF_WORKBENCH-FE_0001232164": "Message Category",
        "P_YS_PF_MANAGER-FE_0001087863": "Operations",
        "P_YS_PF_WORKBENCH-FE_0001133309": "System: visible to enterprise administrators only",
        "P_YS_PF_WORKBENCH-FE_0001232165": "Last 3 Days",
        "P_YS_PF_WORKBENCH-FE_0001133427": "Upgrade to Enterprise",
        "P_YS_PF_MANAGER-FE_0001087865": "In PC Client",
        "P_YS_PF_WORKBENCH-FE_0001133428": "Menu Name",
        "P_YS_OA_XTLCZX_0000030680": "I Initiated",
        "P_YS_PF_WORKBENCH-FE_0001232163": "Deployment Fee",
        "P_YS_OA_XTLCZX_0000030202": "Big",
        "P_YS_PF_WORKBENCH-FE_0001133421": "Yonyou Cloud provides all kinds of digital services that my company needs,",
        "P_YS_PF_WORKBENCH-FE_0001133422": "Global Search",
        "P_YS_FED_EXAMP_0000020395": "Search",
        "P_YS_PF_WORKBENCH-FE_0001133420": "Email:diwork@yonyou.com",
        "P_YS_IPAAS_UCG_0001064071": "Transportation, Warehousing and Postal Services",
        "P_YS_SD_SDMAUF_0000151876": "Please fill in",
        "P_YS_PF_MANAGER-FE_0001087868": "Please choose an industry",
        "P_YS_PF_WORKBENCH-FE_0001133425": "Customization Services",
        "P_YS_PF_MANAGER-FE_0001087867": "Icon size must be 120*120 and cannot exceed 5M!",
        "P_YS_PF_WORKBENCH-FE_0001133426": "Professional pre-sales team across the country, ready to go anytime",
        "P_YS_FED_EXAMP_0000020391": "Loading...",
        "P_YS_PF_WORKBENCH-FE_0001133423": "Menu Position",
        "P_YS_PF_WORKBENCH-FE_0001245212": "Top-Bottom",
        "P_YS_PF_WORKBENCH-FE_0001133424": " new App(s).",
        "P_YS_SD_SDMB-UI_0001160783": "Display Profile Photo",
        "P_YS_PF_YHTTNT-FE_0001045676": "Display Admin Only",
        "P_YS_FED_EXAMP_0000020385": "Cancel",
        "P_YS_PF_WORKBENCH-FE_0001145762": "I know. Do not prompt again",
        "P_YS_FED_FW_0000022510": "Restore Default",
        "P_YS_OA_XTLCZX_0000030679": "Medium",
        "P_YS_PF_WORKBENCH-FE_0001145764": "The product you bought will expire soon",
        "P_YS_PF_WORKBENCH-FE_0001145763": "The product you bought has expired",
        "P_YS_SD_SDMB_0000146962": "Top",
        "P_YS_PF_WORKBENCH-FE_0001145765": "View Now",
        "P_YS_FED_FW_0000022512": "No search result",
        "P_YS_PF_WORKBENCH-FE_0001233366": "Support switching between the old and new version of the workbench at any time",
        "P_YS_PF_WORKBENCH-FE_0001233365": "Switch to Old Version of Workbench",
        "P_YS_PF_MANAGER-FE_0001087877": "Hong Kong Special Administrative Region of China",
        "P_YS_FED_UCFBASEDOC_0000024690": "Group Name (no more than 4 chars)",
        "P_YS_PF_MANAGER-FE_0001087870": "Staff",
        "P_YS_PF_MANAGER-FE_0001087873": "Invite not Allowed",
        "P_YS_FI_CM_0000029930": "OK",
        "P_YS_PF_MANAGER-FE_0001087872": "Cannot be more than 6 Chinese chars or 12 letters.",
        "P_YS_PF_PROCENTER_0000023062": "Other",
        "P_YS_HR_HRPXF_0000055999": "Award Honor",
        "P_YS_FED_IMP_IOT0000005499": "All",
        "OA_web_footer_000000023": "Beijing CIN 11010802021935",
        "P_YS_FED_UCFBASEDOC_0000025417": "Rename",
        "P_YS_FED_FW_0000022200": "Current",
        "P_YS_PF_PROCENTER_0000026339": "Contact",
        "P_YS_OA_XTLCZX_0000030607": "Stretch",
        "P_YS_HR_HRJQF_0000054222": "Date Range",
        "P_YS_FED_FW_0000022205": "Move Down",
        "P_YS_PF_MANAGER-FE_0001087885": "Photo",
        "P_YS_PF_MANAGER-FE_0001087882": "Download Link",
        "P_YS_PF_MANAGER-FE_0001087884": "Forbidden",
        "P_YS_PF_MANAGER-FE_0001087883": "Add to Mobile Homepage",
        "P_YS_FED_IMP-DFM-FE_0000020888": "No.",
        "P_YS_PF_GZTTMP_0000073996": "Education",
        "P_YS_OA_XTNEIBUQUN_0000046136": "Invite Member",
        "P_YS_FED_EXAMP_0000020566": "WeChat",
        "P_YS_PF_METADATA_0000084287": "Authorizations Used",
        "P_YS_OA_XTSPZX_0000034688": "Data Source",
        "P_YS_FED_UCFBASEDOC_0000025523": "Group name already exists",
        "P_YS_FED_EXAMP_0000020207": "Approved",
        "P_YS_FED_FW_0000022215": "Group",
        "P_YS_FED_UCFBASEDOC_0000025400": "Confirm to delete the item?",
        "P_YS_PF_MANAGER-FE_0001087899": "Failed to upload icon",
        "P_YS_PF_MANAGER-FE_0001087893": "No more than 60 chars",
        "P_YS_PF_WORKBENCH-FE_0001155883": "Some Apps in the product you purchased will expire soon. Please renew in time",
        "P_YS_PF_MANAGER-FE_0001087895": "Free of Login",
        "P_YS_PF_WORKBENCH-FE_0001155882": "Some Apps in the product you purchased have expired. Please renew as soon as possible",
        "P_YS_PF_GZTSYS_0000013012": "App Settings",
        "P_YS_OA_XTMENHU_0000046601": "You can add up to 19 Apps",
        "P_YS_OA_XTMENHU_0000046725": "Add Link",
        "P_YS_SD_SDMA_0000041132": "Expired",
        "P_YS_OA_XTSPZX_0000034674": "New App",
        "P_YS_PF_AUTHF_0000112877": "Enter service name",
        "P_YS_PF_GZTLOG_0000028817": "Request failed",
        "P_YS_OA_XTMENHU_0000046721": "Happy birthday!",
        "P_YS_PF_GZTSYS_0000013245": "Service Type",
        "P_YS_PF_MANAGER-FE_0001087891": "Based on Org manager",
        "P_YS_FED_IMP_IOT0000005471": "Prompt",
        "P_YS_OA_XTMENHU_0000046605": "Pending Approval",
        "P_YS_PF_GZTTMP_0000079164": "Message Status",
        "P_YS_PF_MANAGER-FE_0001087788": "Quit from Enterprise",
        "P_YS_PF_METADATA_0000088627": "Feedback",
        "P_YS_OA_XTSPZX_0000034661": "Mobile",
        "P_YS_OA_XTMENHU_0000046711": "QR Code Invitation",
        "P_YS_FI_CM_0000029607": "Error",
        "P_YS_PF_WORKBENCH-FE_0001204986": "Please enter the service name (up to 15 Chinese characters)",
        "P_YS_FED_EXAMP_0000020462": "Clear",
        "P_YS_FED_EXAMP_0000020344": "No",
        "P_YS_OA_XTMENHU_0000046710": " persons' birthday!",
        "P_YS_FI_GL_0000088728": "Allowed",
        "P_YS_FED_FW_0001097161": "Clicking OK will close the page and all the editing will be discarded. Continue?",
        "P_YS_PF_AUTHF_0000112885": "No result",
        "P_YS_PF_GZTSYS_0000109539": "Trad. Chinese"
    },
    "zhtw": {
        "P_YS_SD_SDMAF_0000136493": "發郵件",
        "P_YS_PF_MES-FE_0001269113": "單據標題",
        "P_YS_FI_CM_0000026181": "有",
        "P_YS_PF_PROCENTER_0000027341": "應用",
        "P_YS_SD_SDMAUF_0000153186": "企業地址",
        "P_YS_PF_WORKBENCH-FE_0001133355": "產品模塊定制",
        "P_YS_PF_WORKBENCH-FE_0001133356": "日過期",
        "P_YS_PF_WORKBENCH-FE_0001133353": "讓我能夠運籌帷幄，時刻掌握公司的經營情況",
        "P_YS_PF_WORKBENCH-FE_0001133354": "修改業務日期",
        "P_YS_PF_WORKBENCH-FE_0001133359": "我的首選",
        "P_YS_PF_WORKBENCH-FE_0001228612": "頁面屬性設置",
        "P_YS_PF_WORKBENCH-FE_0001228611": "圖片模糊",
        "P_YS_PF_WORKBENCH-FE_0001133357": "首頁設置",
        "P_YS_PF_WORKBENCH-FE_0001228610": "圖片蒙版",
        "P_YS_PF_WORKBENCH-FE_0001133358": "門戶",
        "P_YS_PF_WORKBENCH-FE_0001133362": "最多打開20個分頁，請關閉不需要的分頁。",
        "P_YS_PF_WORKBENCH-FE_0001228609": "卡片間距",
        "P_YS_PF_GZTSYS_0000012650": "應用管理",
        "P_YS_PF_WORKBENCH-FE_0001133363": "能夠有精力更關注每一位員工，賦能與激活團隊",
        "P_YS_PF_WORKBENCH-FE_0001228608": "頁面寬度",
        "P_YS_PF_WORKBENCH-FE_0001133360": "退出後，您在當前團隊下的應用將不能再使用，相應的數據也將被刪除，請確認數據已備份",
        "P_YS_PF_WORKBENCH-FE_0001228607": "固定寬度",
        "P_YS_PF_WORKBENCH-FE_0001133361": "未知搜索結果",
        "P_YS_SD_SDMA-UI_0001140473": "組件鏈接",
        "P_YS_FI_ETL_0000111653": "本地",
        "P_YS_PF_WORKBENCH-FE_0001233073": "菜單結構有所改動",
        "P_YS_PF_WORKBENCH-FE_0001233072": "切換舊版",
        "P_YS_FED_UCFBASEDOC_0000025292": "未添加",
        "P_YS_PF_WORKBENCH-FE_0001233071": "新菜單",
        "P_YS_PF_WORKBENCH-FE_0001133366": "用友網路科技股份有限公司 © Copyright 2018 京ICP備05007539號-24 京ICP證100714號",
        "P_YS_PF_WORKBENCH-FE_0001233070": "個性化配置與租戶切換",
        "P_YS_PF_WORKBENCH-FE_0001133367": "搜索您想查找的功能、通訊錄等 信息。",
        "P_YS_PF_WORKBENCH-FE_0001133364": "星空藍",
        "P_YS_PF_WORKBENCH-FE_0001133365": "專屬化定制",
        "P_YS_PF_WORKBENCH-FE_0001228600": "友空間歡迎您!",
        "P_YS_PF_WORKBENCH-FE_0001133368": "功能服務發布",
        "P_YS_PF_WORKBENCH-FE_0001133369": "電郵號",
        "P_YS_FED_FW_0000021969": "上傳圖片",
        "P_YS_PF_WORKBENCH-FE_0001133370": "電話溝通",
        "P_YS_PF_WORKBENCH-FE_0001133373": "· 企業級統一基礎檔案與數據管控",
        "P_YS_FED_IMP_IOT0000005567": "確認",
        "P_YS_PF_WORKBENCH-FE_0001133374": "退出全屏",
        "P_YS_OA_XTMENHU_0000046575": "組件地址",
        "P_YS_FED_EXAMP_0000020762": "企業",
        "P_YS_PF_WORKBENCH-FE_0001133371": "查看您的使用記錄",
        "P_YS_OA_app_xtywlj_0000037365": "忽略",
        "P_YS_PF_WORKBENCH-FE_0001133372": "“我是一名研發工程師”",
        "P_YS_PF_PRINT_0000072986": "暫無相關內容",
        "P_YS_PF_GUIDE_0001071542": "必須是一個圖片",
        "P_YS_PF_YS-LOGIN_0001079584": "你點擊了這個圖標；調用參數為：",
        "P_YS_PF_WORKBENCH-FE_0001233069": "此處可進行菜單的切換",
        "P_YS_PF_WORKBENCH-FE_0001233068": "租戶切換",
        "P_YS_FED_UCFBASEDOC_0000025165": "添加分組",
        "P_YS_FED_UCFBASEDOC_0000025164": "拖動下方磁貼至右側所需位置",
        "P_YS_FED_UCFBASEDOC_0000025043": "添加快捷方式至首頁",
        "P_YS_SD_SDMAF_0000137369": "自適應",
        "P_YS_PF_WORKBENCH-FE_0001133377": "專家團隊，根據企業需求，提供產品方_x0008_案",
        "country66": "泰國",
        "P_YS_PF_WORKBENCH-FE_0001133378": "移交團隊",
        "country65": "新加坡",
        "P_YS_PF_WORKBENCH-FE_0001133375": "免費咨詢",
        "P_YS_PF_WORKBENCH-FE_0001133376": "· 企業級應用市場提供全方位數字化服務入口",
        "country63": "菲律賓",
        "country62": "印度尼西亞",
        "country61": "澳大利亞",
        "P_YS_PF_WORKBENCH-FE_0001133379": "請先輸入菜單名稱",
        "country60": "馬來西亞",
        "P_YS_PF_WORKBENCH-FE_0001133380": "淡雅藍",
        "P_YS_PF_WORKBENCH-FE_0001133381": "點擊確定後即將刷新頁面，是否繼續？",
        "P_YS_PF_WORKBENCH-FE_0001196918": "Copyright ©2023",
        "P_YS_PF_WORKBENCH-FE_0001133384": "“我是一名人力資源經理”",
        "P_YS_PF_WORKBENCH-FE_0001133385": "提供產品部署方案，可隨意選擇需要的產品",
        "P_YS_PF_WORKBENCH-FE_0001133382": "需要切換到對應的企業查看詳情，是否切換?",
        "P_YS_PF_WORKBENCH-FE_0001133383": "管理：默認企業賬號管理員可見，可通過角色授權給其他用戶",
        "P_YS_PF_YS-LOGIN_0001079475": "接口未返回數據",
        "P_YS_PF_WORKBENCH-FE_0001245170": "“門戶管理”改為“工作臺管理”，且入口從“協同配置”處移動到“系統管理”處",
        "P_YS_FED_IMP_IOT_0000129791": "功能名稱",
        "P_YS_FED_FW_0000020962": "簡體中文",
        "P_YS_PF_GZTTMP_0000079071": "單據時間",
        "P_YS_FED_FW_0000020961": "保存成功",
        "P_YS_PF_WORKBENCH-FE_0001237311": "多設備登錄提示",
        "P_YS_PF_WORKBENCH-FE_0001237312": "搜索服務名稱",
        "P_YS_PF_WORKBENCH-FE_0001237313": "登錄並剔除其他用戶",
        "P_YS_PF_WORKBENCH-FE_0001237314": "未找到相關結果",
        "P_YS_PF_WORKBENCH-FE_0001237315": "你的帳號已在其他設備或流覽器中登錄，是否強制登錄?",
        "P_YS_PF_WORKBENCH-FE_0001237316": "不登錄",
        "P_YS_PF_WORKBENCH-FE_0001237317": "登錄並保留其他用戶",
        "P_YS_PF_MES-FE_0001269122": "介面錯誤",
        "P_YS_PF_WORKBENCH-FE_0001237318": "你的帳號已在其他設備或流覽器中登錄，是否繼續登錄?",
        "P_YS_PF_WORKBENCH-FE_0001237319": "登錄管理提示",
        "P_YS_HR_HRPXF_0000055966": "請輸入團隊名稱",
        "P_YS_PF_WORKBENCH-FE_0001133388": "產品模塊可部署到專屬機房，免去您的安全擔憂",
        "P_YS_PF_MANAGER-FE_0001087904": "禁止用戶申請加入",
        "P_YS_PF_WORKBENCH-FE_0001133389": "收費咨詢",
        "P_YS_PF_WORKBENCH-FE_0001133386": "PC客戶端",
        "P_YS_PF_WORKBENCH-FE_0001203344": "關閉其它",
        "P_YS_PF_WORKBENCH-FE_0001133387": "解散後，當期團隊下的應用將不能再使用，相應的數據也將被刪除，請確認數據已備份",
        "P_YS_PF_WORKBENCH-FE_0001228620": "企業組件",
        "P_YS_PF_WORKBENCH-FE_0001133391": "“我是一位企業家”",
        "P_YS_PF_WORKBENCH-FE_0001133392": "mdf加載完畢，可以執行打開",
        "P_YS_PF_WORKBENCH-FE_0001271682": "用戶調研",
        "P_YS_PF_WORKBENCH-FE_0001133390": "請搜索被移交用戶",
        "P_YS_PF_WORKBENCH-FE_0001228613": "蒙版透明度",
        "P_YS_PF_WORKBENCH-FE_0001271683": "【溫馨提示】用戶調研點擊這裏使用，期待您的參與",
        "P_YS_PF_WORKBENCH-FE_0001133395": "未加入任何企業",
        "P_YS_PF_WORKBENCH-FE_0001133396": "頁面中有未保存的數據，點擊確定後將重新打開此頁面，是否繼續？",
        "P_YS_FED_IMP_IOT0000005424": "編輯",
        "P_YS_FED_EXAMP_0000020660": "我的",
        "P_YS_PF_AUTHF_0000096113": "5條/頁",
        "P_YS_FED_FW_0000021948": "分類",
        "P_YS_PF_WORKBENCH-FE_0001133393": "申請服務",
        "P_YS_PF_WORKBENCH-FE_0001133394": "售前人員將與您取得聯繫，和您討論定制需求",
        "P_YS_FED_FW_0000177597": "立即升級",
        "P_YS_HR_HRXCF_0000056202": "電郵格式錯誤",
        "P_YS_OA_XTMENHUCMS_0000044985": "組件",
        "P_YS_FI_CM_0000029891": "請輸入驗證碼",
        "P_YS_PF_WORKBENCH-FE_0001133319": "退出團隊",
        "P_YS_PF_WORKBENCH-FE_0001133317": "工作效率越來越高，和團隊間溝通、協作的更便捷。",
        "P_YS_PF_WORKBENCH-FE_0001133438": "用友雲，讓我的工作越來越有章法",
        "P_YS_PF_WORKBENCH-FE_0001133318": "專家咨詢團隊提供一對一解決方案",
        "P_YS_PF_WORKBENCH-FE_0001133439": "菜單入口：",
        "P_YS_PF_YS-LOGIN_0001196671": "京ICP 備05007539號-24",
        "P_YS_PF_GZTTMP_0000075890": "手機端",
        "P_YS_PF_WORKBENCH-FE_0001133311": "· 基礎假勤與薪資查詢服務",
        "P_YS_PF_WORKBENCH-FE_0001133432": "“我是一名IT運維經理”",
        "P_YS_FI_FCWEB_0001048519": "最近使用",
        "P_YS_OA_XTMENHU_0000046660": "發起時間：",
        "P_YS_PF_MANAGER-FE_0001087915": "移動端主頁、summerId選填一個",
        "P_YS_PF_WORKBENCH-FE_0001133312": "馬上定制",
        "P_YS_PF_WORKBENCH-FE_0001133433": "未購買開通任何服務",
        "P_YS_OA_XTMENHU_0000046780": "暫無審批",
        "P_YS_PF_WORKBENCH-FE_0001133430": "添加分頁",
        "P_YS_PF_WORKBENCH-FE_0001133310": "地址：北京市海淀區北清路68號用友產業園",
        "P_YS_PF_WORKBENCH-FE_0001133431": "缺少必須參數：serviceCode",
        "P_YS_OA_XTMENHU_0000046540": "文字模式",
        "P_YS_PF_MANAGER-FE_0001087912": "運行環境版本",
        "P_YS_PF_WORKBENCH-FE_0001133315": "歷史記錄：",
        "P_YS_PF_WORKBENCH-FE_0001133436": "mdf正在加載中",
        "P_YS_PF_WORKBENCH-FE_0001133316": "用友雲，提供的人力共享服務",
        "P_YS_PF_WORKBENCH-FE_0001133437": "專家團隊上門",
        "P_YS_PF_WORKBENCH-FE_0001133313": "不切換",
        "P_YS_PF_WORKBENCH-FE_0001133434": "智能通訊",
        "P_YS_PF_WORKBENCH-FE_0001133314": "掃描下載客戶端",
        "P_YS_PF_WORKBENCH-FE_0001133435": "正在升級企業...",
        "P_YS_PF_GZTSYS_0000012336": "開放平台",
        "P_YS_PF_WORKBENCH-FE_0001274545": "暫無新成員",
        "P_YS_PF_GZTSYS_0000015967": "設置",
        "P_YS_PF_WORKBENCH-FE_0001274544": "未知部門",
        "P_YS_PF_WORKBENCH-FE_0001274543": "請輸入組件鏈接",
        "P_YS_OA_XTTMCENTER_0000035088": "用友官網",
        "P_YS_PF_WORKBENCH-FE_0001274542": "快捷應用",
        "P_YS_SD_SDMB_0000146914": "北京總部",
        "P_YS_PF_MANAGER-FE_0001087908": "確認移除所選用戶？",
        "P_YS_PF_WORKBENCH-FE_0001133440": "解散團隊",
        "P_YS_OA_XTMENHU_0000046542": "模式選擇",
        "P_YS_IPAAS_UCG_0001063993": "水利、環境和公共設施管理業",
        "P_YS_IPAAS_UCG_0001063994": "信息傳輸、計算機服務和軟件業",
        "P_YS_FED_FW_0000021994": "設為默認",
        "P_YS_FED_EXAMP_0000020713": "手機號",
        "P_YS_PF_WORKBENCH-FE_0001274549": "內容名稱",
        "P_YS_OA_LCGL_0000037233": "用戶名稱",
        "P_YS_PF_WORKBENCH-FE_0001274548": "按提交時間最早",
        "P_YS_FED_UCFBASEDOC_0000025257": "搜索內容...",
        "P_YS_FED_FW_0000021874": "類型",
        "P_YS_PF_WORKBENCH-FE_0001274547": "單據類型/提交時間",
        "P_YS_PF_WORKBENCH-FE_0001274546": "最大顯示數量",
        "P_YS_FED_UCFBASEDOC_0000025253": "立即註冊",
        "P_YS_PF_MANAGER-FE_0001087800": "移除成員",
        "P_YS_PF_WORKBENCH-FE_0001133328": "典雅灰",
        "P_YS_PF_WORKBENCH-FE_0001133449": "收起標籤欄",
        "P_YS_PF_MANAGER-FE_0001087920": "免登策略",
        "P_YS_PF_WORKBENCH-FE_0001133329": "展開標籤欄",
        "P_YS_FED_UCFBASEDOC_0000025251": "請輸入手機號",
        "P_YS_PF_MANAGER-FE_0001087806": "瀏覽器新頁",
        "P_YS_PF_WORKBENCH-FE_0001133322": "· 更嚴格的企業成員管理",
        "P_YS_PF_WORKBENCH-FE_0001133443": "點擊不保存，則最新修改將丟失",
        "P_YS_PF_MANAGER-FE_0001087926": "上傳本地圖標",
        "P_YS_PF_WORKBENCH-FE_0001133323": "成員權限",
        "P_YS_PF_WORKBENCH-FE_0001133444": "每到月底和年底，我們總是加班加點，才勉強完成 各種各樣的財務報表",
        "P_YS_PF_WORKBENCH-FE_0001133320": "“我是一名財務經理”",
        "P_YS_PF_WORKBENCH-FE_0001133441": "錄入您的個人信息，方便我們與您取得聯繫",
        "P_YS_PF_MANAGER-FE_0001087807": "允許用戶退出",
        "P_YS_PF_WORKBENCH-FE_0001133321": "業務：必須通過角色授權",
        "P_YS_PF_WORKBENCH-FE_0001133442": "返回官網",
        "P_YS_PF_MANAGER-FE_0001087923": "web端打開方式",
        "P_YS_PF_WORKBENCH-FE_0001133326": "切換企業",
        "P_YS_PF_WORKBENCH-FE_0001133447": "移除成功!",
        "P_YS_PF_MANAGER-FE_0001087922": "請輸入服務名稱",
        "P_YS_PF_WORKBENCH-FE_0001133327": "熱線電話：010-62438888",
        "P_YS_PF_WORKBENCH-FE_0001133448": "個人主頁",
        "P_YS_PF_MANAGER-FE_0001087925": "圖標尺寸必須為120*120的JPG、GIF、PNG圖片且尺寸不大於5M",
        "P_YS_PF_MANAGER-FE_0001087804": "服務名稱不能多於6個漢字或者12個字母",
        "P_YS_PF_WORKBENCH-FE_0001133324": "分組名稱,最多12個字符",
        "P_YS_PF_WORKBENCH-FE_0001133445": "您當前所在的網絡環境可能使您無法訪問幫助中心，請連接到公網再嘗試。",
        "P_YS_PF_WORKBENCH-FE_0001133325": "數據正在加載中....",
        "P_YS_PF_WORKBENCH-FE_0001133446": "在這裡可以找到全部的功能",
        "P_YS_PF_GZTSYS_0000012589": "審批",
        "P_YS_FED_EXAMP_0000020600": "是",
        "P_YS_PF_WORKBENCH-FE_0001133450": "團隊頭像",
        "P_YS_PF_WORKBENCH-FE_0001133330": "· 基於管理角色的應用權限管理",
        "P_YS_PF_WORKBENCH-FE_0001133451": "確認移除所選用戶?",
        "P_YS_OA_XTMENHU_0000046775": "選擇好友",
        "P_YS_FI_FCWEB_0001047535": "全屏顯示",
        "P_YS_OA_XTMENHU_0000046539": "生日祝福",
        "P_YS_OA_LCGL_0000037221": "用戶編碼",
        "P_YS_PF_MANAGER-FE_0001087811": ">2000人",
        "P_YS_PF_WORKBENCH-FE_0001133339": "升級為企業後您可以獲得更多權限",
        "P_YS_FED_UCFBASEDOC_0000025483": "已添加",
        "P_YS_HR_HRJXF_0000059541": "驗證失敗",
        "P_YS_PF_WORKBENCH-FE_0001220704": "動態",
        "P_YS_PF_GZTSYS_0000109035": "我的常用",
        "P_YS_PF_MANAGER-FE_0001087817": "請輸入企業地址",
        "P_YS_PF_WORKBENCH-FE_0001133333": "將鏈接發給小夥伴就可以啦",
        "P_YS_PF_WORKBENCH-FE_0001133454": "上門演示",
        "P_YS_PF_MANAGER-FE_0001087937": "請選擇規模範圍",
        "P_YS_PF_WORKBENCH-FE_0001133334": "資料",
        "P_YS_PF_WORKBENCH-FE_0001133331": "關閉全部分頁",
        "P_YS_PF_WORKBENCH-FE_0001133452": "個應用即將到期，",
        "P_YS_PF_GZTPRE_0000071076": "所屬應用",
        "P_YS_PF_WORKBENCH-FE_0001133332": "升級企業",
        "P_YS_PF_WORKBENCH-FE_0001133453": "經營企業，我不再焦慮",
        "P_YS_PF_WORKBENCH-FE_0001133337": "莫蘭迪黃",
        "P_YS_PF_MANAGER-FE_0001087933": "管理員邀請",
        "P_YS_PF_WORKBENCH-FE_0001133338": "您的企業新增了",
        "P_YS_SD_UDHWS_0000070064": "企業名稱",
        "P_YS_PF_WORKBENCH-FE_0001133335": "應用續費",
        "P_YS_PF_MANAGER-FE_0001087814": "是否使用原生導航",
        "P_YS_PF_WORKBENCH-FE_0001133336": "請填寫圖形驗證碼",
        "P_YS_OA_XTMENHU_0000046569": "工作通知",
        "P_YS_PF_GZTSYS_0000012679": "團隊管理",
        "P_YS_PF_WORKBENCH-FE_0001133340": "團隊應用",
        "P_YS_OA_XTMENHU_0000046686": "提交人：",
        "P_YS_PF_MANAGER-FE_0001087809": "中國澳門特別行政區",
        "P_YS_PF_WORKBENCH-FE_0001133341": "根據您的需求，我們可以提供專家團隊上門解決方案",
        "P_YS_FED_IMP_IOT0000005514": "下一步",
        "P_YS_IPAAS_UCG_0001063976": "採礦業",
        "P_YS_FED_FW_0000021612": "加載失敗",
        "P_YS_HR_HRXCF_0000072788": "請選擇數據來源",
        "P_YS_FED_FW_0000021852": "刷新",
        "P_YS_FED_EXAMP_0000020736": "收起",
        "P_YS_PF_MANAGER-FE_0001087820": "1001－2000",
        "P_YS_PF_MANAGER-FE_0001087941": "退出後，您在當前企業下的應用將不能再使用，相應的數據也將被刪除，請確認數據已備份",
        "P_YS_SD_SDMAF_0000137211": "恢復默認設置",
        "P_YS_PF_MANAGER-FE_0001087943": "手機號格式錯誤",
        "P_YS_OA_XTRIZHI_0000036826": "我的收藏",
        "P_YS_PF_WORKBENCH-FE_0001133344": "電話：010-62438888",
        "P_YS_PF_MANAGER-FE_0001087827": "是否原生",
        "P_YS_PF_WORKBENCH-FE_0001133345": "服務流程",
        "P_YS_PF_WORKBENCH-FE_0001133342": "用友雲，讓我們每天都可以跟蹤公司的實時財務數據，真正使財務成為業務的一部分",
        "P_YS_FI_CM_0000026177": "已審批",
        "P_YS_PF_MANAGER-FE_0001087829": "app原生導航",
        "P_YS_PF_WORKBENCH-FE_0001133343": "功能圖標",
        "P_YS_PF_MANAGER-FE_0001087945": "請輸入在友空間桌面端打開時跳轉地址",
        "P_YS_PF_WORKBENCH-FE_0001133348": "· 企業級組織架構管理",
        "P_YS_PF_MANAGER-FE_0001087823": "選擇默認圖標",
        "P_YS_PF_WORKBENCH-FE_0001133349": "請輸入圖形驗證碼",
        "P_YS_PF_WORKBENCH-FE_0001133346": "登出",
        "P_YS_PF_WORKBENCH-FE_0001133347": "菜單路徑",
        "P_YS_PF_GZTSYS_0001010812": "企業認證",
        "P_YS_OA_XTMENHU_0000046557": "未讀微郵",
        "P_YS_PF_WORKBENCH-FE_0001133351": "確定設置當前用戶為管理員？",
        "P_YS_OA_XTMENHU_0000046675": "送祝福",
        "P_YS_PF_WORKBENCH-FE_0001133352": "我的門戶",
        "P_YS_PF_PRINT_0000106816": "垂直居中",
        "P_YS_OA_XTMENHU_0000046556": "請輸入自定義組件的網絡地址",
        "P_YS_PF_WORKBENCH-FE_0001133350": "用友集團",
        "P_YS_FED_UCFBASEDOC_0000025589": "發布成功",
        "P_YS_FED_UCFBASEDOC_0000025345": "移動到",
        "P_YS_SD_SDMBF_0000141689": "到期時間：",
        "OA_web_statistics_000000106": "產品名稱",
        "P_YS_PF_WORKBENCH-FE_0001208723": "界面放大",
        "P_YS_PF_WORKBENCH-FE_0001228574": "友小秘",
        "P_YS_PF_WORKBENCH-FE_0001208722": "超大",
        "P_YS_SD_SDMAUF_0000153108": "雲客服",
        "P_YS_OA_XTTMCENTER_0000035047": "友空間",
        "P_YS_OA_XTMENHUCMS_0000045340": "最前",
        "P_YS_OA_XTTMCENTER_0000035043": "鏈接",
        "P_YS_FED_EXAMP_0000019931": "電郵",
        "P_YS_IPAAS_UCG_0001064402": "房地產業",
        "P_YS_SD_SDMBF_0000144965": "展示方式",
        "P_YS_PF_GZTSYS_0000012812": "待辦",
        "P_YS_OA_XTMENHUCMS_0000045344": "IOS跳轉參數",
        "P_YS_PF_GZTSYS_0000012814": "團隊",
        "P_YS_SD_SDMBF_0000142527": "請點擊",
        "P_YS_HR_HRJQ_0000031105": "未處理",
        "P_YS_FED_EXAMP_0000019939": "確定",
        "P_YS_PF_WORKBENCH-FE_0001228566": "廣告詳情",
        "P_YS_PF_WORKBENCH-FE_0001228565": "數字內容",
        "P_YS_OA_XTTMCENTER_0000035058": "用友雲官網",
        "P_YS_IPAAS_UCG_0001064652": "製造業",
        "P_YS_PF_WORKBENCH-FE_0001274451": "sed 執行報錯",
        "P_YS_PF_WORKBENCH-FE_0001274450": "臨時檔夾位置",
        "P_YS_IPAAS_UCG_0001064416": "環境和公共設施管理業、社會保障和社會組織",
        "P_YS_FED_FW_0000022192": "上移",
        "P_YS_PF_WORKBENCH-FE_0001228592": "大",
        "000357": "删除文件",
        "P_YS_FED_FW_0000022197": "展開",
        "P_YS_PF_WORKBENCH-FE_0001228597": "確定要恢復默認設置嗎?",
        "P_YS_PF_WORKBENCH-FE_0001228599": "卡片編輯",
        "P_YS_PF_WORKBENCH-FE_0001228598": "恢復提示",
        "P_YS_OA_LCSJ_0001130313": "之前",
        "P_YS_OA_XTTMCENTER_0000035064": "下載",
        "P_YS_FED_EXAMP_0000019832": "、",
        "P_YS_OA_XTTMCENTER_0000035062": "客戶端下載",
        "P_YS_FI_IA_0000054929": "單據類型",
        "P_YS_PF_WORKBENCH-FE_0001274449": "刪除目錄",
        "P_YS_PF_WORKBENCH-FE_0001274448": "捕獲多語地址",
        "P_YS_HR_HRYGF_0000058823": "升級",
        "P_YS_PF_WORKBENCH-FE_0001243713": "功能引導",
        "P_YS_PF_MANAGER-FE_0001116216": "是否全員可見",
        "P_YS_PF_METADATA_0000087187": "所屬領域",
        "P_YS_PF_METADATA_0000086098": "用戶信息",
        "P_YS_PF_WORKBENCH-FE_0001228589": "卡片屬性設置",
        "P_YS_PF_WORKBENCH-FE_0001274556": "”調用失敗，DomID：",
        "P_YS_PF_WORKBENCH-FE_0001274555": "\"磁貼的渲染函數“",
        "P_YS_PF_WORKBENCH-FE_0001274554": "按提交時間最晚",
        "P_YS_PF_WORKBENCH-FE_0001274553": "磁貼的屬性渲染失敗“",
        "P_YS_PF_AUTHF_0000096078": "20條/頁",
        "P_YS_PF_WORKBENCH-FE_0001274552": "請輸入最大顯示數量",
        "P_YS_PF_WORKBENCH-FE_0001274551": "請輸入請求地址",
        "P_YS_IPAAS_UCG_0001064631": "科學研究、技術服務和地質勘查業",
        "P_YS_PF_WORKBENCH-FE_0001274550": "按單據類型",
        "P_YS_PF_WORKBENCH-FE_0001238259": "待辦通知",
        "P_YS_PF_WORKBENCH-FE_0001274558": "介面返回格式",
        "P_YS_OA_XTMENHUCMS_0000045311": "統一審批中心",
        "P_YS_PF_WORKBENCH-FE_0001274557": "請輸入內容名稱",
        "P_YS_PF_SOCD-S_0000183662": "企業管理",
        "P_YS_PF_WORKBENCH-FE_0001133399": "移交團隊後您將不再有管理員權限。",
        "P_YS_PF_WORKBENCH-FE_0001133397": "鏈接複製成功，趕快發送給你的小夥伴吧!",
        "P_YS_PF_WORKBENCH-FE_0001133398": "數字化工作入口",
        "country84": "越南",
        "P_YS_SD_UDHMC_0000050938": "跳過",
        "P_YS_OA_XTTMCENTER_0000035122": "管理員",
        "P_YS_OA_XTMENHUCMS_0000045143": "快捷應用",
        "P_YS_SD_UDHWN_0000121225": "最近一月",
        "P_YS_OA_XTMENHUCMS_0000045382": "Android下載地址",
        "P_YS_IPAAS_UCG_0001064325": "建築業",
        "P_YS_SD_SDMA_0000060355": "幫助中心",
        "P_YS_IPAAS_UCG_0001064207": "居民服務和其他服務業",
        "P_YS_PF_GZTSYS_0000011889": "榮耀",
        "P_YS_FI_CM_0000029021": "跳至",
        "P_YS_HR_HRJQ_0000031143": "無",
        "P_YS_FED_UCFBASEDOC_0000025096": "您確認要刪除服務",
        "country95": "緬甸",
        "P_YS_OA_XTTXL_0000045969": "發消息",
        "P_YS_OA_XTMENHUCMS_0000045376": "服務器地址",
        "P_YS_IPAAS_UCG_0001064571": "租賃和商務服務業",
        "P_YS_OA_XTMENHUCMS_0000045375": "移動端主頁",
        "P_YS_FED_FW_0000021923": "知道了",
        "P_YS_PF_GZTSYS_0000012860": "動態",
        "P_YS_SD_UDHWN_0000120386": "立即申請",
        "P_YS_IPAAS_UCG_0001064578": "金融、保險業",
        "P_YS_PF_GZTSYS_0000012505": "基礎設置",
        "P_YS_IPAAS_UCG_0001009417": "釘釘",
        "P_YS_FI_CM_0000030025": "到期時間",
        "P_YS_FED_EXAMP_0000019906": "更多",
        "P_YS_PF_WORKBENCH-FE_0001217140": "請至少選擇一個客戶端",
        "P_YS_OA_XTMENHUCMS_0000045362": "Android跳轉參數",
        "P_YS_OA_XTTMCENTER_0000035140": "退出",
        "P_YS_HR_HRJQ_0000031030": "最後",
        "P_YS_PF_WORKBENCH-FE_0001232883": "切換新版",
        "P_YS_OA_XTMENHUCMS_0000045366": "在當前頁面打開",
        "P_YS_PF_WORKBENCH-FE_0001232882": "個人工作臺",
        "P_YS_FED_UCFBASEDOC_0000025079": "發布失敗",
        "P_YS_SCM_PU_0000028707": "商家",
        "P_YS_SD_UDHWN_0000122693": "最近一周",
        "P_YS_OA_XTMENHUCMS_0000045353": "IOS下載地址",
        "P_YS_OA_XTMENHUCMS_0000045352": "發布客戶端",
        "P_YS_OA_XTTMCENTER_0000035034": "聯繫我們",
        "P_YS_PF_GZTSYS_0000011990": "門戶頁面管理",
        "P_YS_HR_HRRCPDF_0000071186": "用友網絡科技股份有限公司",
        "P_YS_OA_XTMENHUCMS_0000045359": "在新頁面打開",
        "P_YS_HR_HRPXF_0000056053": "團隊名稱",
        "P_YS_PF_WORKBENCH-FE_0001229381": "選擇磁貼",
        "P_YS_PF_MANAGER-FE_0001087797": "所有用戶都可申請加入",
        "P_YS_PF_WORKBENCH-FE_0001229380": "拖拽進行排序",
        "P_YS_PF_MANAGER-FE_0001087794": "姓名、手機號碼、電郵",
        "P_YS_PF_WORKBENCH-FE_0001229385": "建議為87的整數倍",
        "P_YS_PF_MANAGER-FE_0001087793": "通訊錄顯示水印",
        "P_YS_PF_WORKBENCH-FE_0001229384": "自定義高度",
        "P_YS_PF_MANAGER-FE_0001087796": "pcClient打開方式",
        "P_YS_OA_XTLCZX_0000030256": "抄送的",
        "P_YS_PF_WORKBENCH-FE_0001229383": "內容設置",
        "P_YS_PF_MANAGER-FE_0001087795": "根據匯入的上下級關係顯示上下級",
        "P_YS_PF_WORKBENCH-FE_0001229382": "富文本內容設置",
        "P_YS_PF_WORKBENCH-FE_0001229388": "顯示姓名",
        "P_YS_SD_SDMAF_0001008026": "創建成功！",
        "P_YS_PF_WORKBENCH-FE_0001229387": "顯示通知",
        "P_YS_PF_WORKBENCH-FE_0001229386": "組件高度",
        "P_YS_PF_GZTSYS_0000013194": "工作台",
        "P_YS_PF_GZTSYS_0001025942": "門戶廣告位設置",
        "P_YS_IPAAS_UCG_0001064361": "農、林、牧、漁業",
        "P_YS_OA_XTTXL_0000045990": "管理",
        "P_YS_FED_UCFBASEDOC_0000025619": "添加文件夾",
        "P_YS_IPAAS_UCG_0001064369": "國際組織",
        "P_YS_FED_IMP_IOT0000008165": "刪除",
        "P_YS_FED_UCFBASEDOC_0000025614": "手機",
        "P_YS_IPAAS_UCG_0001064009": "住宿、餐飲業",
        "P_YS_FED_FW_0000022366": "修改成功！",
        "P_YS_PF_WORKBENCH-FE_0001229374": "廣告位資源可在“門戶廣告位設置”中設置",
        "P_YS_PF_WORKBENCH-FE_0001229373": "存在多張廣告圖時，設定圖片播放間隔",
        "P_YS_PF_WORKBENCH-FE_0001229377": "是否啟用自定義",
        "P_YS_PF_WORKBENCH-FE_0001229376": "關聯廣告",
        "P_YS_PF_WORKBENCH-FE_0001229375": "圖片輪播間隔",
        "P_YS_IPAAS_UCG_0001064490": "文化、體育、娛樂業",
        "P_YS_PF_WORKBENCH-FE_0001229379": "搜索應用名稱",
        "P_YS_IPAAS_UCG_0001064251": "衛生、社會保障和社會服務業",
        "P_YS_OA_XTMENHUCMS_0000045298": "圖片樣式",
        "P_YS_OA_XTMENHUCMS_0000045174": "廣告位",
        "P_YS_IPAAS_UCG_0001064138": "電力、熱力、燃氣及水的生產和供應業",
        "P_YS_FED_UCFBASEDOC_0000024755": "刪除文件夾",
        "P_YS_FED_UCFBASEDOC_0000025601": "請輸入電郵",
        "P_YS_FED_UCFBASEDOC_0000024752": "您確認要刪除此項服務？",
        "P_YS_FED_UCFBASEDOC_0000024870": "查看詳情",
        "P_YS_PF_AUTHF_0000080113": "10條/頁",
        "P_YS_FED_FW_0000021020": "新增",
        "P_YS_OA_XTMENHUCMS_0000045290": "背景顏色",
        "P_YS_SD_SDMAUF_0000152315": "之後",
        "P_YS_OA_XTMENHUCMS_0000045287": "常用應用",
        "P_YS_OA_XTMENHUCMS_0000045284": "圖標大小設置",
        "P_YS_OA_XTMENHUCMS_0000045041": "組件名稱",
        "P_YS_FED_UCFBASEDOC_0000024748": "您確認要批量刪除嗎？",
        "P_YS_PF_GZTLOG_0000080270": "Web端",
        "P_YS_FED_UCFBASEDOC_0000024866": "是否保存最新修改？",
        "P_YS_FED_FW_0000022466": "默認",
        "P_YS_FED_FW_0000021376": "中國",
        "P_YS_OA_XTSPZX_0000034639": "領域",
        "P_YS_FED_FW_0000021379": "北京",
        "P_YS_FED_UCFBASEDOC_0000024982": "不保存",
        "P_YS_OA_XTMENHUCMS_0000045168": "消息中心",
        "P_YS_SCM_STOCK_0000034455": "未讀",
        "P_YS_PF_WORKBENCH-FE_0001241019": "工作台",
        "P_YS_OA_XTTMCENTER_0000035108": "用友雲市場",
        "P_YS_PF_MANAGER-FE_0001120439": "錯誤的參數：applicationId",
        "P_YS_PF_GZTLOG_0000025976": "鎖定",
        "P_YS_FED_FW_0000022475": "所屬行業",
        "P_YS_SD_SDMBF_0000144334": "請上傳圖片",
        "P_YS_OA_XTMENHUCMS_0000045158": "工作門戶",
        "P_YS_FI_CM_0000029097": "今天",
        "P_YS_FI_FA_0000056249": "新增卡片",
        "P_YS_FED_EXAMP_0000020397": "姓名",
        "P_YS_FED_FW_0000022168": "請輸入關鍵字",
        "P_YS_PF_AUTHF_0000080120": "15條/頁",
        "P_YS_OA_XTLCZX_0000030221": "系統",
        "P_YS_FED_FW_0000022064": "暫無數據",
        "P_YS_IPAAS_UCG_0001064293": "批發和零售業",
        "P_YS_PF_WORKBENCH-FE_0001202943": "固定導航",
        "P_YS_PF_WORKBENCH-FE_0001202944": "菜單鎖定",
        "P_YS_PF_WORKBENCH-FE_0001202945": "導航切換",
        "P_YS_PF_WORKBENCH-FE_0001202946": "解除固定",
        "P_YS_PF_WORKBENCH-FE_0001202941": "快捷導航",
        "P_YS_PF_WORKBENCH-FE_0001202942": "全局導航",
        "country886": "中國台灣",
        "P_YS_FI_FCWEB_0001048065": "工作台設置",
        "P_YS_PF_GZTSYS_0000011939": "我的門戶管理",
        "P_YS_SD_SDMB_0000146348": "服務支持",
        "P_YS_FED_FW_0000022179": "對齊方式",
        "P_YS_PF_WORKBENCH-FE_0001202947": "快捷導航設置",
        "P_YS_FED_UCFBASEDOC_0000024951": "無內容的分組在首頁不可見",
        "P_YS_OA_XTLCZX_0000030219": "搜索結果",
        "P_YS_PF_GZTSYS_0000012902": "其它",
        "P_YS_SD_SDMAUF_0000152873": "歷史記錄",
        "P_YS_PF_PROCENTER_0000022591": "校驗失敗",
        "P_YS_PF_WORKBENCH-FE_0001212762": "快捷搜索",
        "P_YS_SCM_STOCK_0000034523": "已讀",
        "P_YS_SD_SDMAUF_0000152518": "還有",
        "P_YS_FED_EXAMP_0000020183": "關閉",
        "P_YS_PF_WORKBENCH-FE_0001153504": "不再提醒",
        "P_YS_PF_WORKBENCH-FE_0001137268": "忽略，不再提醒",
        "P_YS_FED_UCFBASEDOC_0000024820": "到",
        "P_YS_FED_UCFBASEDOC_0000024942": "添加",
        "P_YS_OA_app_xtyyjm_0000035755": "待審批",
        "P_YS_OA_XTLCZX_0000030480": "小",
        "P_YS_FED_UCFBASEDOC_0000024938": "刪除服務",
        "P_YS_FED_UCFBASEDOC_0000024930": "請輸入聯繫人姓名",
        "P_YS_OA_XTLCZX_0000030238": "背景圖片",
        "P_YS_OA_app_xtyyjm_0000035750": "成員",
        "P_YS_PF_WORKBENCH-FE_0001212760": "”相關結果，請重新輸入",
        "P_YS_PF_WORKBENCH-FE_0001212761": "未搜索到“",
        "P_YS_PF_WORKBENCH-FE_0001233364": "工作臺個性化配置能力增強",
        "P_YS_SD_SDMB_0000139191": "消息詳情",
        "P_YS_PF_WORKBENCH-FE_0001233363": "支持更多磁貼、更靈活佈局、更豐富的展示效果",
        "P_YS_PF_WORKBENCH-FE_0001233362": "門戶合併到工作臺啦，支持多工作臺切換，角色化工作臺幫助您更好完成工作任務",
        "P_YS_PF_MANAGER-FE_0001087832": "申請權限",
        "P_YS_PF_WORKBENCH-FE_0001233361": "企業帳號換位置啦",
        "P_YS_FED_UCFBASEDOC_0000025581": "重命名分組",
        "P_YS_PF_WORKBENCH-FE_0001233360": "數位化工作入口升級啦",
        "P_YS_OA_XTMENHUCMS_0000044935": "發言",
        "P_YS_PF_GZTSYS_0000109255": "獲取驗證碼失敗",
        "P_YS_PLM_BASE-FE_0001160596": "頂部對齊",
        "P_YS_OA_XTMENHUCMS_0000044934": "長廣告位",
        "P_YS_OA_YBMOB_0000036991": "審批詳情",
        "P_YS_SD_SDMA_0000123136": "主頁",
        "P_YS_PF_MANAGER-FE_0001087834": "請輸入在友空間APP打開時跳轉地址",
        "P_YS_PF_MANAGER-FE_0001087957": "請輸入Android下載地址",
        "P_YS_PF_MANAGER-FE_0001087836": "請輸入IOS下載地址",
        "P_YS_FED_EXAMP_0000020115": "切換",
        "P_YS_FED_EXAMP_0000020236": "複製鏈接",
        "P_YS_OA_XTMENHU_0000046746": "預警通知",
        "P_YS_OA_XTMENHU_0000046620": "鏈接名稱",
        "P_YS_SD_UDHMC_0000051143": "請輸入企業名稱",
        "P_YS_PF_WORKBENCH-FE_0001233359": "菜單導航優化",
        "P_YS_PF_WORKBENCH-FE_0001233358": "企業帳號轉移到用戶下拉麵板啦",
        "P_YS_FED_UCFBASEDOC_0000025215": "登錄",
        "P_YS_PF_WORKBENCH-FE_0001233357": "工作臺配置能力更強\\n菜單導航更高效",
        "P_YS_PF_WORKBENCH-FE_0001233356": "支持多工作臺",
        "P_YS_PF_WORKBENCH-FE_0001233355": "全新的菜單面板，新增搜索功能，支持快速收藏和查看最近使用",
        "P_YS_OA_app_xtywlj_0000037879": "所屬分類",
        "P_YS_PF_MANAGER-FE_0001087842": "跳轉參數",
        "P_YS_PF_WORKBENCH-FE_0001133407": "全部歷史",
        "P_YS_PF_MANAGER-FE_0001087841": "全員邀請",
        "P_YS_PF_WORKBENCH-FE_0001133408": "用友雲，完全公有雲化的企業服務，讓我從傳統的運維 工作解放出來，成為公司數據資產的建設者",
        "P_YS_PF_MANAGER-FE_0001087844": "請選擇是否原生",
        "P_YS_PF_WORKBENCH-FE_0001133405": "開啟錄製",
        "P_YS_PF_MANAGER-FE_0001087964": "PC客戶端主頁",
        "P_YS_PF_MANAGER-FE_0001087843": "請輸入上傳到iUAP平台的安裝包ID",
        "P_YS_PF_WORKBENCH-FE_0001133406": "搜索人員信息、服務及其他內容",
        "P_YS_OA_XTWEIYOU_0000046270": "同時發送郵件",
        "P_YS_FED_FW_0000055346": "請選擇數據",
        "P_YS_PF_MANAGER-FE_0001087840": "Web端主頁",
        "P_YS_PF_MANAGER-FE_0001087961": "是否常用應用",
        "P_YS_PF_WORKBENCH-FE_0001133409": "移除首頁",
        "P_YS_PF_WORKBENCH-FE_0001133400": "個應用已到期，",
        "P_YS_FI_CM_0000029500": "頁",
        "P_YS_PF_MANAGER-FE_0001087846": "是否離線應用",
        "P_YS_PF_WORKBENCH-FE_0001133403": "團隊設置",
        "P_YS_PF_MANAGER-FE_0001087966": "上下級顯示",
        "P_YS_PF_WORKBENCH-FE_0001133404": "讓我從很多重複性的事務工作中解放出來",
        "P_YS_PF_MANAGER-FE_0001087848": "邀請規則",
        "P_YS_PF_WORKBENCH-FE_0001133401": "背景色設定",
        "P_YS_PF_MANAGER-FE_0001087847": "請輸入在Web瀏覽器打開時跳轉地址",
        "P_YS_PF_WORKBENCH-FE_0001133402": "更多結果",
        "P_YS_FED_EXAMP_0000020005": "模板",
        "P_YS_PF_WORKBENCH-FE_0001242095": "還未添加收藏,快去收藏吧",
        "P_YS_PF_WORKBENCH-FE_0001242096": "暫不了解",
        "P_YS_PF_GZTSYS_0000013477": "保存",
        "P_YS_PF_METADATA_0000084364": "請求地址",
        "P_YS_PF_GZTSYS_0000015896": "團隊成員",
        "P_YS_FI_CM_0000028899": "退出登錄",
        "P_YS_OA_XTLCZX_0000030776": "正常",
        "P_YS_FED_UCFBASEDOC_0000025203": "獲取驗證碼",
        "P_YS_PF_WORKBENCH-FE_0001233465": "开始了解",
        "P_YS_OA_XTMENHU_0000046739": "我的任務",
        "P_YS_OA_XTMENHU_0000046618": "我的項目",
        "P_YS_FED_UCFBASEDOC_0000025200": "移動",
        "P_YS_OA_XTNEIBUQUN_0000046122": "設置管理員",
        "P_YS_PF_WORKBENCH-FE_0001133418": "每天維護公司的上百台服務器，總是怕出現一些問題， 影響公司業務發展",
        "P_YS_PF_MANAGER-FE_0001087852": "請上傳服務圖標",
        "P_YS_PF_WORKBENCH-FE_0001133419": "填寫信息",
        "P_YS_HR_HRSBF_0001183870": "個人設置",
        "P_YS_PF_WORKBENCH-FE_0001133416": "發布到菜單",
        "P_YS_PF_WORKBENCH-FE_0001133417": "電郵：diwork@yonyou.com",
        "P_YS_OA_XTLCZX_0000030555": "平鋪",
        "P_YS_PF_WORKBENCH-FE_0001232171": "剩餘數",
        "P_YS_PF_WORKBENCH-FE_0001232170": "更早",
        "P_YS_PF_WORKBENCH-FE_0001133410": "“相信美好，立刻開始數字化工作”",
        "P_YS_PF_WORKBENCH-FE_0001133411": "關閉錄製",
        "P_YS_PF_WORKBENCH-FE_0001133414": "中查看。",
        "P_YS_PF_WORKBENCH-FE_0001133415": "當前租戶已開啟登錄控制策略。控制方式為【驗證碼】",
        "P_YS_PF_WORKBENCH-FE_0001133412": "帳號管理",
        "P_YS_OA_YBMOB_0000036890": "文件",
        "P_YS_PF_MANAGER-FE_0001087858": "置頂優先級",
        "P_YS_PF_WORKBENCH-FE_0001133413": "如需購買或了解產品詳情請撥打熱線",
        "P_YS_FED_EXAMP_0000020016": "首頁",
        "P_YS_OA_XTMENHU_0000046646": "鏈接邀請",
        "P_YS_SD_SDMA_0000098308": "頁面設置",
        "P_YS_OA_XTMENHU_0000046524": "待辦中心",
        "P_YS_PF_WORKBENCH-FE_0001245211": "左右排列",
        "P_YS_PF_GZTSYS_0000013325": "標籤",
        "P_YS_OA_XTMENHU_0000046644": "空間管理",
        "P_YS_OA_XTMENHU_0000046523": "圖文模式",
        "P_YS_FED_UCFBASEDOC_0000025319": "驗證碼",
        "P_YS_PF_METADATA_0000085782": "產品編碼",
        "P_YS_HR_HRJQF_0000054364": "匯入完成",
        "P_YS_OA_app_xtyyjm_0000035782": "選擇報表",
        "P_YS_PF_WORKBENCH-FE_0001232168": "獲取數據異常，請刷新",
        "P_YS_OA_app_xtywlj_0000037618": "業務",
        "P_YS_PF_WORKBENCH-FE_0001232169": "佔用率",
        "P_YS_PF_WORKBENCH-FE_0001232166": "授權佔用明細",
        "P_YS_PF_WORKBENCH-FE_0001232167": "授權數",
        "P_YS_HR_HRCOREF_0000058092": "當前人數",
        "P_YS_PF_WORKBENCH-FE_0001133429": "掃描二維碼直接進入",
        "P_YS_PF_WORKBENCH-FE_0001232164": "消息分類",
        "P_YS_PF_MANAGER-FE_0001087863": "相關操作",
        "P_YS_PF_WORKBENCH-FE_0001133309": "系統：僅企業賬號管理員可見",
        "P_YS_PF_WORKBENCH-FE_0001232165": "最近三天",
        "P_YS_PF_WORKBENCH-FE_0001133427": "升級為企業",
        "P_YS_PF_MANAGER-FE_0001087865": "pc客戶端內",
        "P_YS_PF_WORKBENCH-FE_0001133428": "菜單名稱：",
        "P_YS_OA_XTLCZX_0000030680": "我發起的",
        "P_YS_PF_WORKBENCH-FE_0001232163": "部署費",
        "P_YS_OA_XTLCZX_0000030202": "大",
        "P_YS_PF_WORKBENCH-FE_0001133421": "用友雲提供了企業所需要的各種數字化服務",
        "P_YS_PF_WORKBENCH-FE_0001133422": "全局搜索：",
        "P_YS_FED_EXAMP_0000020395": "搜索",
        "P_YS_PF_WORKBENCH-FE_0001133420": "聯繫電郵：diwork@yonyou.com",
        "P_YS_IPAAS_UCG_0001064071": "交通運輸、倉儲業和郵政業",
        "P_YS_SD_SDMAUF_0000151876": "請填寫",
        "P_YS_PF_MANAGER-FE_0001087868": "請選擇所屬行業",
        "P_YS_PF_WORKBENCH-FE_0001133425": "定製服務",
        "P_YS_PF_MANAGER-FE_0001087867": "圖標尺寸須為120*120，且不大於5M！",
        "P_YS_PF_WORKBENCH-FE_0001133426": "遍布全國的專業售前團隊，整裝待命",
        "P_YS_FED_EXAMP_0000020391": "加載中...",
        "P_YS_PF_WORKBENCH-FE_0001133423": "菜單位置：",
        "P_YS_PF_WORKBENCH-FE_0001245212": "上下排列",
        "P_YS_PF_WORKBENCH-FE_0001133424": "個應用，",
        "P_YS_SD_SDMB-UI_0001160783": "顯示頭像",
        "P_YS_PF_YHTTNT-FE_0001045676": "只顯示管理員",
        "P_YS_FED_EXAMP_0000020385": "取消",
        "P_YS_PF_WORKBENCH-FE_0001145762": "已知曉，不再提示",
        "P_YS_FED_FW_0000022510": "恢復默認",
        "P_YS_OA_XTLCZX_0000030679": "中",
        "P_YS_PF_WORKBENCH-FE_0001145764": "您購買的產品即將過期",
        "P_YS_PF_WORKBENCH-FE_0001145763": "您購買的產品已經到期",
        "P_YS_SD_SDMB_0000146962": "返回頂部",
        "P_YS_PF_WORKBENCH-FE_0001145765": "立即查看",
        "P_YS_FED_FW_0000022512": "沒有搜索結果",
        "P_YS_PF_WORKBENCH-FE_0001233366": "支持回到舊版，可以隨時切換回到新版工作臺",
        "P_YS_PF_WORKBENCH-FE_0001233365": "切換舊版工作臺",
        "P_YS_PF_MANAGER-FE_0001087877": "中國香港特別行政區",
        "P_YS_FED_UCFBASEDOC_0000024690": "分組名稱,最多4個字符",
        "P_YS_PF_MANAGER-FE_0001087870": "規模範圍",
        "P_YS_PF_MANAGER-FE_0001087873": "禁止邀請",
        "P_YS_FI_CM_0000029930": "我知道了",
        "P_YS_PF_MANAGER-FE_0001087872": "不能多於6個漢字或者12個字母",
        "P_YS_PF_PROCENTER_0000023062": "其他",
        "P_YS_HR_HRPXF_0000055999": "發榮耀",
        "P_YS_FED_IMP_IOT0000005499": "全部",
        "OA_web_footer_000000023": "京公網安備 11010802021935號",
        "P_YS_FED_UCFBASEDOC_0000025417": "重命名文件夾",
        "P_YS_FED_FW_0000022200": "當前",
        "P_YS_PF_PROCENTER_0000026339": "聯繫人信息",
        "P_YS_OA_XTLCZX_0000030607": "拉伸",
        "P_YS_HR_HRJQF_0000054222": "日期範圍",
        "P_YS_FED_FW_0000022205": "下移",
        "P_YS_PF_MANAGER-FE_0001087885": "企業頭像",
        "P_YS_PF_MANAGER-FE_0001087882": "下載地址",
        "P_YS_PF_MANAGER-FE_0001087884": "禁止",
        "P_YS_PF_MANAGER-FE_0001087883": "推薦到移動端首頁",
        "P_YS_FED_IMP-DFM-FE_0000020888": "序號",
        "P_YS_PF_GZTTMP_0000073996": "教育",
        "P_YS_OA_XTNEIBUQUN_0000046136": "邀請成員",
        "P_YS_FED_EXAMP_0000020566": "微信",
        "P_YS_PF_METADATA_0000084287": "占用數",
        "P_YS_OA_XTSPZX_0000034688": "數據來源",
        "P_YS_FED_UCFBASEDOC_0000025523": "分組名稱已存在！",
        "P_YS_FED_EXAMP_0000020207": "通過",
        "P_YS_FED_FW_0000022215": "分組",
        "P_YS_FED_UCFBASEDOC_0000025400": "您確認要刪除此項？",
        "P_YS_PF_MANAGER-FE_0001087899": "上傳圖標失敗！",
        "P_YS_PF_MANAGER-FE_0001087893": "最多60個字符",
        "P_YS_PF_WORKBENCH-FE_0001155883": "您購買的產品中，有應用即將到期，請及時安排續費！",
        "P_YS_PF_MANAGER-FE_0001087895": "集成免登策略",
        "P_YS_PF_WORKBENCH-FE_0001155882": "您購買的產品中，有應用已到期，請儘快安排續費！",
        "P_YS_PF_GZTSYS_0000013012": "應用設置",
        "P_YS_OA_XTMENHU_0000046601": "最多添加19個應用",
        "P_YS_OA_XTMENHU_0000046725": "添加鏈接",
        "P_YS_SD_SDMA_0000041132": "已過期",
        "P_YS_OA_XTSPZX_0000034674": "添加應用",
        "P_YS_PF_AUTHF_0000112877": "輸入服務名稱",
        "P_YS_PF_GZTLOG_0000028817": "請求失敗",
        "P_YS_OA_XTMENHU_0000046721": "祝你生日快樂，永遠十八歲！",
        "P_YS_PF_GZTSYS_0000013245": "服務類型",
        "P_YS_PF_MANAGER-FE_0001087891": "根據組織機構負責人顯示上下級",
        "P_YS_FED_IMP_IOT0000005471": "提示",
        "P_YS_OA_XTMENHU_0000046605": "待辦審批",
        "P_YS_PF_GZTTMP_0000079164": "消息狀態",
        "P_YS_PF_MANAGER-FE_0001087788": "退出企業",
        "P_YS_PF_METADATA_0000088627": "回報問題",
        "P_YS_OA_XTSPZX_0000034661": "移動端",
        "P_YS_OA_XTMENHU_0000046711": "二維碼邀請",
        "P_YS_FI_CM_0000029607": "錯誤",
        "P_YS_PF_WORKBENCH-FE_0001204986": "請輸入服務名稱(最多15個漢字)",
        "P_YS_FED_EXAMP_0000020462": "清空",
        "P_YS_FED_EXAMP_0000020344": "否",
        "P_YS_OA_XTMENHU_0000046710": "個人生日哦",
        "P_YS_FI_GL_0000088728": "允許",
        "P_YS_FED_FW_0001097161": "頁面中有未保存的數據，點擊確定後將關閉頁面，是否繼續？",
        "P_YS_PF_AUTHF_0000112885": "暫無結果",
        "P_YS_PF_GZTSYS_0000109539": "繁體中文"
    },
    "zhcn": {
        "P_YS_SD_SDMAF_0000136493": "发邮件",
        "P_YS_PF_MES-FE_0001269113": "单据标题",
        "P_YS_FI_CM_0000026181": "有",
        "P_YS_PF_PROCENTER_0000027341": "应用",
        "P_YS_SD_SDMAUF_0000153186": "企业地址",
        "P_YS_PF_WORKBENCH-FE_0001133355": "产品模块定制",
        "P_YS_PF_WORKBENCH-FE_0001133356": "日过期",
        "P_YS_PF_WORKBENCH-FE_0001133353": "让我能够运筹帷幄，时刻掌握公司的经营情况",
        "P_YS_PF_WORKBENCH-FE_0001133354": "修改业务日期",
        "P_YS_PF_WORKBENCH-FE_0001133359": "我的首选",
        "P_YS_PF_WORKBENCH-FE_0001228612": "页面属性设置",
        "P_YS_PF_WORKBENCH-FE_0001228611": "图片模糊",
        "P_YS_PF_WORKBENCH-FE_0001133357": "首页设置",
        "P_YS_PF_WORKBENCH-FE_0001228610": "图片蒙版",
        "P_YS_PF_WORKBENCH-FE_0001133358": "门户",
        "P_YS_PF_WORKBENCH-FE_0001133362": "最多打开20个页签，请关闭不需要的页签。",
        "P_YS_PF_WORKBENCH-FE_0001228609": "卡片间距",
        "P_YS_PF_GZTSYS_0000012650": "应用管理",
        "P_YS_PF_WORKBENCH-FE_0001133363": "能够有精力更关注每一位员工，赋能与激活团队",
        "P_YS_PF_WORKBENCH-FE_0001228608": "页面宽度",
        "P_YS_PF_WORKBENCH-FE_0001133360": "退出后，您在当前团队下的应用将不能再使用，相应的数据也将被删除，请确认数据已备份",
        "P_YS_PF_WORKBENCH-FE_0001228607": "固定宽度",
        "P_YS_PF_WORKBENCH-FE_0001133361": "未知搜索结果",
        "P_YS_SD_SDMA-UI_0001140473": "组件链接",
        "P_YS_FI_ETL_0000111653": "本地",
        "P_YS_PF_WORKBENCH-FE_0001233073": "菜单结构有所改动",
        "P_YS_PF_WORKBENCH-FE_0001233072": "切换旧版",
        "P_YS_FED_UCFBASEDOC_0000025292": "未添加",
        "P_YS_PF_WORKBENCH-FE_0001233071": "新菜单",
        "P_YS_PF_WORKBENCH-FE_0001133366": "用友网络科技股份有限公司 © Copyright 2018 京ICP备05007539号-24 京ICP证100714号",
        "P_YS_PF_WORKBENCH-FE_0001233070": "个性化配置与租户切换",
        "P_YS_PF_WORKBENCH-FE_0001133367": "搜索您想查找的功能、通讯录等 信息。",
        "P_YS_PF_WORKBENCH-FE_0001133364": "星空蓝",
        "P_YS_PF_WORKBENCH-FE_0001133365": "专属化定制",
        "P_YS_PF_WORKBENCH-FE_0001228600": "友空间欢迎您!",
        "P_YS_PF_WORKBENCH-FE_0001133368": "功能服务发布",
        "P_YS_PF_WORKBENCH-FE_0001133369": "邮箱号",
        "P_YS_FED_FW_0000021969": "上传图片",
        "P_YS_PF_WORKBENCH-FE_0001133370": "电话沟通",
        "P_YS_PF_WORKBENCH-FE_0001133373": "· 企业级统一基础档案与数据管控",
        "P_YS_FED_IMP_IOT0000005567": "确认",
        "P_YS_PF_WORKBENCH-FE_0001133374": "退出全屏",
        "P_YS_OA_XTMENHU_0000046575": "组件地址",
        "P_YS_FED_EXAMP_0000020762": "企业",
        "P_YS_PF_WORKBENCH-FE_0001133371": "查看您的使用记录",
        "P_YS_OA_app_xtywlj_0000037365": "忽略",
        "P_YS_PF_WORKBENCH-FE_0001133372": "“我是一名研发工程师”",
        "P_YS_PF_PRINT_0000072986": "暂无相关内容",
        "P_YS_PF_GUIDE_0001071542": "必须是一个图片",
        "P_YS_PF_YS-LOGIN_0001079584": "你点击了这个图标；调用参数为：",
        "P_YS_PF_WORKBENCH-FE_0001233069": "此处可进行菜单的切换",
        "P_YS_PF_WORKBENCH-FE_0001233068": "租户切换",
        "P_YS_FED_UCFBASEDOC_0000025165": "添加分组",
        "P_YS_FED_UCFBASEDOC_0000025164": "拖动下方磁贴至右侧所需位置",
        "P_YS_FED_UCFBASEDOC_0000025043": "添加快捷方式至首页",
        "P_YS_SD_SDMAF_0000137369": "自适应",
        "P_YS_PF_WORKBENCH-FE_0001133377": "专家团队，根据企业需求，提供产品方\b案",
        "country66": "泰国",
        "P_YS_PF_WORKBENCH-FE_0001133378": "移交团队",
        "country65": "新加坡",
        "P_YS_PF_WORKBENCH-FE_0001133375": "免费咨询",
        "P_YS_PF_WORKBENCH-FE_0001133376": "· 企业级应用市场提供全方位数字化服务入口",
        "country63": "菲律宾",
        "country62": "印度尼西亚",
        "country61": "澳大利亚",
        "P_YS_PF_WORKBENCH-FE_0001133379": "请先输入菜单名称",
        "country60": "马来西亚",
        "P_YS_PF_WORKBENCH-FE_0001133380": "淡雅蓝",
        "P_YS_PF_WORKBENCH-FE_0001133381": "点击确定后即将刷新页面，是否继续？",
        "P_YS_PF_WORKBENCH-FE_0001196918": "Copyright ©2023",
        "P_YS_PF_WORKBENCH-FE_0001133384": "“我是一名人力资源经理”",
        "P_YS_PF_WORKBENCH-FE_0001133385": "提供产品部署方案，可随意选择需要的产品",
        "P_YS_PF_WORKBENCH-FE_0001133382": "需要切换到对应的企业查看详情，是否切换?",
        "P_YS_PF_WORKBENCH-FE_0001133383": "管理：默认企业账号管理员可见，可通过角色授权给其他用户",
        "P_YS_PF_YS-LOGIN_0001079475": "接口未返回数据",
        "P_YS_PF_WORKBENCH-FE_0001245170": "“门户管理”改为“工作台管理”，且入口从“协同配置”处移动到“系统管理”处",
        "P_YS_FED_IMP_IOT_0000129791": "功能名称",
        "P_YS_FED_FW_0000020962": "简体中文",
        "P_YS_PF_GZTTMP_0000079071": "单据时间",
        "P_YS_FED_FW_0000020961": "保存成功",
        "P_YS_PF_WORKBENCH-FE_0001237311": "多设备登录提示",
        "P_YS_PF_WORKBENCH-FE_0001237312": "搜索服务名称",
        "P_YS_PF_WORKBENCH-FE_0001237313": "登录并在其他设备退出",
        "P_YS_PF_WORKBENCH-FE_0001237314": "未找到相关结果",
        "P_YS_PF_WORKBENCH-FE_0001237315": "你的账号已在其它设备或浏览器中登录，是否强制登录?",
        "P_YS_PF_WORKBENCH-FE_0001237316": "不登录",
        "P_YS_PF_WORKBENCH-FE_0001237317": "登录且不退出其他设备",
        "P_YS_PF_MES-FE_0001269122": "接口错误",
        "P_YS_PF_WORKBENCH-FE_0001237318": "你的账号已在其它设备或浏览器中登录，是否继续登录?",
        "P_YS_PF_WORKBENCH-FE_0001237319": "登录管理提示",
        "P_YS_HR_HRPXF_0000055966": "请输入团队名称",
        "P_YS_PF_WORKBENCH-FE_0001133388": "产品模块可部署到专属机房，免去您的安全担忧",
        "P_YS_PF_MANAGER-FE_0001087904": "禁止用户申请加入",
        "P_YS_PF_WORKBENCH-FE_0001133389": "收费咨询",
        "P_YS_PF_WORKBENCH-FE_0001133386": "PC客户端",
        "P_YS_PF_WORKBENCH-FE_0001203344": "关闭其它",
        "P_YS_PF_WORKBENCH-FE_0001133387": "解散后，当期团队下的应用将不能再使用，相应的数据也将被删除，请确认数据已备份",
        "P_YS_PF_WORKBENCH-FE_0001228620": "企业组件",
        "P_YS_PF_WORKBENCH-FE_0001133391": "“我是一位企业家”",
        "P_YS_PF_WORKBENCH-FE_0001133392": "mdf加载完毕，可以执行打开",
        "P_YS_PF_WORKBENCH-FE_0001271682": "用户调研",
        "P_YS_PF_WORKBENCH-FE_0001133390": "请搜索被移交用户",
        "P_YS_PF_WORKBENCH-FE_0001228613": "蒙版透明度",
        "P_YS_PF_WORKBENCH-FE_0001271683": "【温馨提示】用户调研点击这里使用，期待您的参与",
        "P_YS_PF_WORKBENCH-FE_0001133395": "未加入任何企业",
        "P_YS_PF_WORKBENCH-FE_0001133396": "页面中有未保存的数据，点击确定后将重新打开此页面，是否继续？",
        "P_YS_FED_IMP_IOT0000005424": "编辑",
        "P_YS_FED_EXAMP_0000020660": "我的",
        "P_YS_PF_AUTHF_0000096113": "5条/页",
        "P_YS_FED_FW_0000021948": "分类",
        "P_YS_PF_WORKBENCH-FE_0001133393": "申请服务",
        "P_YS_PF_WORKBENCH-FE_0001133394": "售前人员将与您取得联系，和您讨论定制需求",
        "P_YS_FED_FW_0000177597": "立即升级",
        "P_YS_HR_HRXCF_0000056202": "邮箱格式错误",
        "P_YS_OA_XTMENHUCMS_0000044985": "组件",
        "P_YS_FI_CM_0000029891": "请输入验证码",
        "P_YS_PF_WORKBENCH-FE_0001133319": "退出团队",
        "P_YS_PF_WORKBENCH-FE_0001133317": "工作效率越来越高，和团队间沟通、协作的更便捷。",
        "P_YS_PF_WORKBENCH-FE_0001133438": "用友云，让我的工作越来越有章法",
        "P_YS_PF_WORKBENCH-FE_0001133318": "专家咨询团队提供一对一解决方案",
        "P_YS_PF_WORKBENCH-FE_0001133439": "菜单入口：",
        "P_YS_PF_YS-LOGIN_0001196671": "京ICP 备05007539号-24",
        "P_YS_PF_GZTTMP_0000075890": "手机端",
        "P_YS_PF_WORKBENCH-FE_0001133311": "· 基础假勤与薪资查询服务",
        "P_YS_PF_WORKBENCH-FE_0001133432": "“我是一名IT运维经理”",
        "P_YS_FI_FCWEB_0001048519": "最近使用",
        "P_YS_OA_XTMENHU_0000046660": "发起时间：",
        "P_YS_PF_MANAGER-FE_0001087915": "移动端主页、summerId选填一个",
        "P_YS_PF_WORKBENCH-FE_0001133312": "马上定制",
        "P_YS_PF_WORKBENCH-FE_0001133433": "未购买开通任何服务",
        "P_YS_OA_XTMENHU_0000046780": "暂无审批",
        "P_YS_PF_WORKBENCH-FE_0001133430": "添加首页",
        "P_YS_PF_WORKBENCH-FE_0001133310": "地址：北京市海淀区北清路68号用友产业园",
        "P_YS_PF_WORKBENCH-FE_0001133431": "缺少必须参数：serviceCode",
        "P_YS_OA_XTMENHU_0000046540": "文字模式",
        "P_YS_PF_MANAGER-FE_0001087912": "运行环境版本",
        "P_YS_PF_WORKBENCH-FE_0001133315": "历史记录：",
        "P_YS_PF_WORKBENCH-FE_0001133436": "mdf正在加载中",
        "P_YS_PF_WORKBENCH-FE_0001133316": "用友云，提供的人力共享服务",
        "P_YS_PF_WORKBENCH-FE_0001133437": "专家团队上门",
        "P_YS_PF_WORKBENCH-FE_0001133313": "不切换",
        "P_YS_PF_WORKBENCH-FE_0001133434": "智能通讯",
        "P_YS_PF_WORKBENCH-FE_0001133314": "扫描下载客户端",
        "P_YS_PF_WORKBENCH-FE_0001133435": "正在升级企业...",
        "P_YS_PF_GZTSYS_0000012336": "开放平台",
        "P_YS_PF_WORKBENCH-FE_0001274545": "暂无新成员",
        "P_YS_PF_GZTSYS_0000015967": "设置",
        "P_YS_PF_WORKBENCH-FE_0001274544": "未知部门",
        "P_YS_PF_WORKBENCH-FE_0001274543": "请输入组件链接",
        "P_YS_OA_XTTMCENTER_0000035088": "用友官网",
        "P_YS_PF_WORKBENCH-FE_0001274542": "快捷應用",
        "P_YS_SD_SDMB_0000146914": "北京总部",
        "P_YS_PF_MANAGER-FE_0001087908": "确认移除所选用户？",
        "P_YS_PF_WORKBENCH-FE_0001133440": "解散团队",
        "P_YS_OA_XTMENHU_0000046542": "模式选择",
        "P_YS_IPAAS_UCG_0001063993": "水利、环境和公共设施管理业",
        "P_YS_IPAAS_UCG_0001063994": "信息传输、计算机服务和软件业",
        "P_YS_FED_FW_0000021994": "设为默认",
        "P_YS_FED_EXAMP_0000020713": "手机号",
        "P_YS_PF_WORKBENCH-FE_0001274549": "内容名称",
        "P_YS_OA_LCGL_0000037233": "用户名称",
        "P_YS_PF_WORKBENCH-FE_0001274548": "按提交时间最早",
        "P_YS_FED_UCFBASEDOC_0000025257": "搜索内容...",
        "P_YS_FED_FW_0000021874": "类型",
        "P_YS_PF_WORKBENCH-FE_0001274547": "单据类型/提交时间",
        "P_YS_PF_WORKBENCH-FE_0001274546": "最大显示数量",
        "P_YS_FED_UCFBASEDOC_0000025253": "立即注册",
        "P_YS_PF_MANAGER-FE_0001087800": "移除成员",
        "P_YS_PF_WORKBENCH-FE_0001133328": "典雅灰",
        "P_YS_PF_WORKBENCH-FE_0001133449": "收起标签栏",
        "P_YS_PF_MANAGER-FE_0001087920": "免登策略",
        "P_YS_PF_WORKBENCH-FE_0001133329": "展开标签栏",
        "P_YS_FED_UCFBASEDOC_0000025251": "请输入手机号",
        "P_YS_PF_MANAGER-FE_0001087806": "浏览器新页",
        "P_YS_PF_WORKBENCH-FE_0001133322": "· 更严格的企业成员管理",
        "P_YS_PF_WORKBENCH-FE_0001133443": "点击不保存，则最新修改将丢失",
        "P_YS_PF_MANAGER-FE_0001087926": "上传本地图标",
        "P_YS_PF_WORKBENCH-FE_0001133323": "成员权限",
        "P_YS_PF_WORKBENCH-FE_0001133444": "每到月底和年底，我们总是加班加点，才勉强完成 各种各样的财务报表",
        "P_YS_PF_WORKBENCH-FE_0001133320": "“我是一名财务经理”",
        "P_YS_PF_WORKBENCH-FE_0001133441": "录入您的个人信息，方便我们与您取得联系",
        "P_YS_PF_MANAGER-FE_0001087807": "允许用户退出",
        "P_YS_PF_WORKBENCH-FE_0001133321": "业务：必须通过角色授权",
        "P_YS_PF_WORKBENCH-FE_0001133442": "返回官网",
        "P_YS_PF_MANAGER-FE_0001087923": "web端打开方式",
        "P_YS_PF_WORKBENCH-FE_0001133326": "切换企业",
        "P_YS_PF_WORKBENCH-FE_0001133447": "移除成功!",
        "P_YS_PF_MANAGER-FE_0001087922": "请输入服务名称",
        "P_YS_PF_WORKBENCH-FE_0001133327": "热线电话：010-62438888",
        "P_YS_PF_WORKBENCH-FE_0001133448": "个人主页",
        "P_YS_PF_MANAGER-FE_0001087925": "图标尺寸必须为120*120的JPG、GIF、PNG图片且尺寸不大于5M",
        "P_YS_PF_MANAGER-FE_0001087804": "服务名称不能多于6个汉字或者12个字母",
        "P_YS_PF_WORKBENCH-FE_0001133324": "分组名称,最多12个字符",
        "P_YS_PF_WORKBENCH-FE_0001133445": "您当前所在的网络环境可能使您无法访问帮助中心，请连接到公网再尝试。",
        "P_YS_PF_WORKBENCH-FE_0001133325": "数据正在加载中....",
        "P_YS_PF_WORKBENCH-FE_0001133446": "在这里可以找到全部的功能",
        "P_YS_PF_GZTSYS_0000012589": "审批",
        "P_YS_FED_EXAMP_0000020600": "是",
        "P_YS_PF_WORKBENCH-FE_0001133450": "团队头像",
        "P_YS_PF_WORKBENCH-FE_0001133330": "· 基于管理角色的应用权限管理",
        "P_YS_PF_WORKBENCH-FE_0001133451": "确认移除所选用户?",
        "P_YS_OA_XTMENHU_0000046775": "选择好友",
        "P_YS_FI_FCWEB_0001047535": "全屏显示",
        "P_YS_OA_XTMENHU_0000046539": "生日祝福",
        "P_YS_OA_LCGL_0000037221": "用户编码",
        "P_YS_PF_MANAGER-FE_0001087811": ">2000人",
        "P_YS_PF_WORKBENCH-FE_0001133339": "升级为企业后您可以获得更多权限",
        "P_YS_FED_UCFBASEDOC_0000025483": "已添加",
        "P_YS_HR_HRJXF_0000059541": "验证失败",
        "P_YS_PF_WORKBENCH-FE_0001220704": "动态",
        "P_YS_PF_GZTSYS_0000109035": "我的常用",
        "P_YS_PF_MANAGER-FE_0001087817": "请输入企业地址",
        "P_YS_PF_WORKBENCH-FE_0001133333": "将链接发给小伙伴就可以啦",
        "P_YS_PF_WORKBENCH-FE_0001133454": "上门演示",
        "P_YS_PF_MANAGER-FE_0001087937": "请选择规模范围",
        "P_YS_PF_WORKBENCH-FE_0001133334": "资料",
        "P_YS_PF_WORKBENCH-FE_0001133331": "关闭全部页签",
        "P_YS_PF_WORKBENCH-FE_0001133452": "个应用即将到期，",
        "P_YS_PF_GZTPRE_0000071076": "所属应用",
        "P_YS_PF_WORKBENCH-FE_0001133332": "升级企业",
        "P_YS_PF_WORKBENCH-FE_0001133453": "经营企业，我不再焦虑",
        "P_YS_PF_WORKBENCH-FE_0001133337": "莫兰迪黄",
        "P_YS_PF_MANAGER-FE_0001087933": "管理员邀请",
        "P_YS_PF_WORKBENCH-FE_0001133338": "您的企业新增了",
        "P_YS_SD_UDHWS_0000070064": "企业名称",
        "P_YS_PF_WORKBENCH-FE_0001133335": "应用续费",
        "P_YS_PF_MANAGER-FE_0001087814": "是否使用原生导航",
        "P_YS_PF_WORKBENCH-FE_0001133336": "请填写图形验证码",
        "P_YS_OA_XTMENHU_0000046569": "工作通知",
        "P_YS_PF_GZTSYS_0000012679": "团队管理",
        "P_YS_PF_WORKBENCH-FE_0001133340": "团队应用",
        "P_YS_OA_XTMENHU_0000046686": "提交人：",
        "P_YS_PF_MANAGER-FE_0001087809": "中国澳门特别行政区",
        "P_YS_PF_WORKBENCH-FE_0001133341": "根据您的需求，我们可以提供专家团队上门解决方案",
        "P_YS_FED_IMP_IOT0000005514": "下一步",
        "P_YS_IPAAS_UCG_0001063976": "采矿业",
        "P_YS_FED_FW_0000021612": "加载失败",
        "P_YS_HR_HRXCF_0000072788": "请选择数据来源",
        "P_YS_FED_FW_0000021852": "刷新",
        "P_YS_FED_EXAMP_0000020736": "收起",
        "P_YS_PF_MANAGER-FE_0001087820": "1001－2000",
        "P_YS_PF_MANAGER-FE_0001087941": "退出后，您在当前企业下的应用将不能再使用，相应的数据也将被删除，请确认数据已备份",
        "P_YS_SD_SDMAF_0000137211": "恢复默认设置",
        "P_YS_PF_MANAGER-FE_0001087943": "手机号格式错误",
        "P_YS_OA_XTRIZHI_0000036826": "我的收藏",
        "P_YS_PF_WORKBENCH-FE_0001133344": "电话：010-62438888",
        "P_YS_PF_MANAGER-FE_0001087827": "是否原生",
        "P_YS_PF_WORKBENCH-FE_0001133345": "服务流程",
        "P_YS_PF_WORKBENCH-FE_0001133342": "用友云，让我们每天都可以跟踪公司的实时财务数据，真正使财务成为业务的一部分",
        "P_YS_FI_CM_0000026177": "已审批",
        "P_YS_PF_MANAGER-FE_0001087829": "app原生导航",
        "P_YS_PF_WORKBENCH-FE_0001133343": "功能图标",
        "P_YS_PF_MANAGER-FE_0001087945": "请输入在友空间桌面端打开时跳转地址",
        "P_YS_PF_WORKBENCH-FE_0001133348": "· 企业级组织架构管理",
        "P_YS_PF_MANAGER-FE_0001087823": "选择默认图标",
        "P_YS_PF_WORKBENCH-FE_0001133349": "请输入图形验证码",
        "P_YS_PF_WORKBENCH-FE_0001133346": "注销",
        "P_YS_PF_WORKBENCH-FE_0001133347": "菜单路径",
        "P_YS_PF_GZTSYS_0001010812": "企业认证",
        "P_YS_OA_XTMENHU_0000046557": "未读微邮",
        "P_YS_PF_WORKBENCH-FE_0001133351": "确定设置当前用户为管理员？",
        "P_YS_OA_XTMENHU_0000046675": "送祝福",
        "P_YS_PF_WORKBENCH-FE_0001133352": "我的门户",
        "P_YS_PF_PRINT_0000106816": "垂直居中",
        "P_YS_OA_XTMENHU_0000046556": "请输入自定义组件的网络地址",
        "P_YS_PF_WORKBENCH-FE_0001133350": "用友集团",
        "P_YS_FED_UCFBASEDOC_0000025589": "发布成功",
        "P_YS_FED_UCFBASEDOC_0000025345": "移动到",
        "P_YS_SD_SDMBF_0000141689": "到期时间：",
        "OA_web_statistics_000000106": "产品名称",
        "P_YS_PF_WORKBENCH-FE_0001208723": "界面放大",
        "P_YS_PF_WORKBENCH-FE_0001228574": "友小秘",
        "P_YS_PF_WORKBENCH-FE_0001208722": "超大",
        "P_YS_SD_SDMAUF_0000153108": "云客服",
        "P_YS_OA_XTTMCENTER_0000035047": "友空间",
        "P_YS_OA_XTMENHUCMS_0000045340": "最前",
        "P_YS_OA_XTTMCENTER_0000035043": "链接",
        "P_YS_FED_EXAMP_0000019931": "邮箱",
        "P_YS_IPAAS_UCG_0001064402": "房地产业",
        "P_YS_SD_SDMBF_0000144965": "展示方式",
        "P_YS_PF_GZTSYS_0000012812": "待办",
        "P_YS_OA_XTMENHUCMS_0000045344": "IOS跳转参数",
        "P_YS_PF_GZTSYS_0000012814": "团队",
        "P_YS_SD_SDMBF_0000142527": "请点击",
        "P_YS_HR_HRJQ_0000031105": "未处理",
        "P_YS_FED_EXAMP_0000019939": "确定",
        "P_YS_PF_WORKBENCH-FE_0001228566": "广告详情",
        "P_YS_PF_WORKBENCH-FE_0001228565": "数字内容",
        "P_YS_OA_XTTMCENTER_0000035058": "用友云官网",
        "P_YS_IPAAS_UCG_0001064652": "制造业",
        "P_YS_PF_WORKBENCH-FE_0001274451": "sed 执行报错",
        "P_YS_PF_WORKBENCH-FE_0001274450": "临时文件夹位置",
        "P_YS_IPAAS_UCG_0001064416": "环境和公共设施管理业、社会保障和社会组织",
        "P_YS_FED_FW_0000022192": "上移",
        "P_YS_PF_WORKBENCH-FE_0001228592": "大",
        "000357": "删除文件",
        "P_YS_FED_FW_0000022197": "展开",
        "P_YS_PF_WORKBENCH-FE_0001228597": "确定要恢复默认设置吗?",
        "P_YS_PF_WORKBENCH-FE_0001228599": "卡片编辑",
        "P_YS_PF_WORKBENCH-FE_0001228598": "恢复提示",
        "P_YS_OA_LCSJ_0001130313": "之前",
        "P_YS_OA_XTTMCENTER_0000035064": "下载",
        "P_YS_FED_EXAMP_0000019832": "、",
        "P_YS_OA_XTTMCENTER_0000035062": "客户端下载",
        "P_YS_FI_IA_0000054929": "单据类型",
        "P_YS_PF_WORKBENCH-FE_0001274449": "删除目录",
        "P_YS_PF_WORKBENCH-FE_0001274448": "捕获多语地址",
        "P_YS_HR_HRYGF_0000058823": "升级",
        "P_YS_PF_WORKBENCH-FE_0001243713": "功能引导",
        "P_YS_PF_MANAGER-FE_0001116216": "是否全员可见",
        "P_YS_PF_METADATA_0000087187": "所属领域",
        "P_YS_PF_METADATA_0000086098": "用户信息",
        "P_YS_PF_WORKBENCH-FE_0001228589": "卡片属性设置",
        "P_YS_PF_WORKBENCH-FE_0001274556": "”调用失败，DomID：",
        "P_YS_PF_WORKBENCH-FE_0001274555": "\"磁贴的渲染函数“",
        "P_YS_PF_WORKBENCH-FE_0001274554": "按提交时间最晚",
        "P_YS_PF_WORKBENCH-FE_0001274553": "磁贴的属性渲染失败“",
        "P_YS_PF_AUTHF_0000096078": "20条/页",
        "P_YS_PF_WORKBENCH-FE_0001274552": "请输入最大显示数量",
        "P_YS_PF_WORKBENCH-FE_0001274551": "请输入请求地址",
        "P_YS_IPAAS_UCG_0001064631": "科学研究、技术服务和地质勘查业",
        "P_YS_PF_WORKBENCH-FE_0001274550": "按单据类型",
        "P_YS_PF_WORKBENCH-FE_0001238259": "待办通知",
        "P_YS_PF_WORKBENCH-FE_0001274558": "接口返回格式",
        "P_YS_OA_XTMENHUCMS_0000045311": "统一审批中心",
        "P_YS_PF_WORKBENCH-FE_0001274557": "请输入内容名称",
        "P_YS_PF_SOCD-S_0000183662": "企业管理",
        "P_YS_PF_WORKBENCH-FE_0001133399": "移交团队后您将不再有管理员权限。",
        "P_YS_PF_WORKBENCH-FE_0001133397": "链接复制成功，赶快发送给你的小伙伴吧!",
        "P_YS_PF_WORKBENCH-FE_0001133398": "数字化工作入口",
        "country84": "越南",
        "P_YS_SD_UDHMC_0000050938": "跳过",
        "P_YS_OA_XTTMCENTER_0000035122": "管理员",
        "P_YS_OA_XTMENHUCMS_0000045143": "快捷应用",
        "P_YS_SD_UDHWN_0000121225": "最近一月",
        "P_YS_OA_XTMENHUCMS_0000045382": "Android下载地址",
        "P_YS_IPAAS_UCG_0001064325": "建筑业",
        "P_YS_SD_SDMA_0000060355": "帮助中心",
        "P_YS_IPAAS_UCG_0001064207": "居民服务和其他服务业",
        "P_YS_PF_GZTSYS_0000011889": "荣耀",
        "P_YS_FI_CM_0000029021": "跳至",
        "P_YS_HR_HRJQ_0000031143": "无",
        "P_YS_FED_UCFBASEDOC_0000025096": "您确认要删除服务",
        "country95": "缅甸",
        "P_YS_OA_XTTXL_0000045969": "发消息",
        "P_YS_OA_XTMENHUCMS_0000045376": "服务器地址",
        "P_YS_IPAAS_UCG_0001064571": "租赁和商务服务业",
        "P_YS_OA_XTMENHUCMS_0000045375": "移动端主页",
        "P_YS_FED_FW_0000021923": "知道了",
        "P_YS_PF_GZTSYS_0000012860": "动态",
        "P_YS_SD_UDHWN_0000120386": "立即申请",
        "P_YS_IPAAS_UCG_0001064578": "金融、保险业",
        "P_YS_PF_GZTSYS_0000012505": "基础设置",
        "P_YS_IPAAS_UCG_0001009417": "钉钉",
        "P_YS_FI_CM_0000030025": "到期时间",
        "P_YS_FED_EXAMP_0000019906": "更多",
        "P_YS_PF_WORKBENCH-FE_0001217140": "请至少选择一个客户端",
        "P_YS_OA_XTMENHUCMS_0000045362": "Android跳转参数",
        "P_YS_OA_XTTMCENTER_0000035140": "退出",
        "P_YS_HR_HRJQ_0000031030": "最后",
        "P_YS_PF_WORKBENCH-FE_0001232883": "切换新版",
        "P_YS_OA_XTMENHUCMS_0000045366": "在当前页面打开",
        "P_YS_PF_WORKBENCH-FE_0001232882": "个人工作台",
        "P_YS_FED_UCFBASEDOC_0000025079": "发布失败",
        "P_YS_SCM_PU_0000028707": "商家",
        "P_YS_SD_UDHWN_0000122693": "最近一周",
        "P_YS_OA_XTMENHUCMS_0000045353": "IOS下载地址",
        "P_YS_OA_XTMENHUCMS_0000045352": "发布客户端",
        "P_YS_OA_XTTMCENTER_0000035034": "联系我们",
        "P_YS_PF_GZTSYS_0000011990": "门户页面管理",
        "P_YS_HR_HRRCPDF_0000071186": "用友网络科技股份有限公司",
        "P_YS_OA_XTMENHUCMS_0000045359": "在新页面打开",
        "P_YS_HR_HRPXF_0000056053": "团队名称",
        "P_YS_PF_WORKBENCH-FE_0001229381": "选择磁贴",
        "P_YS_PF_MANAGER-FE_0001087797": "所有用户都可申请加入",
        "P_YS_PF_WORKBENCH-FE_0001229380": "拖拽进行排序",
        "P_YS_PF_MANAGER-FE_0001087794": "姓名、手机号码、邮箱",
        "P_YS_PF_WORKBENCH-FE_0001229385": "建议为87的整数倍",
        "P_YS_PF_MANAGER-FE_0001087793": "通讯录显示水印",
        "P_YS_PF_WORKBENCH-FE_0001229384": "自定义高度",
        "P_YS_PF_MANAGER-FE_0001087796": "pcClient打开方式",
        "P_YS_OA_XTLCZX_0000030256": "抄送的",
        "P_YS_PF_WORKBENCH-FE_0001229383": "内容设置",
        "P_YS_PF_MANAGER-FE_0001087795": "根据导入的上下级关系显示上下级",
        "P_YS_PF_WORKBENCH-FE_0001229382": "富文本内容设置",
        "P_YS_PF_WORKBENCH-FE_0001229388": "显示姓名",
        "P_YS_SD_SDMAF_0001008026": "创建成功！",
        "P_YS_PF_WORKBENCH-FE_0001229387": "显示通知",
        "P_YS_PF_WORKBENCH-FE_0001229386": "组件高度",
        "P_YS_PF_GZTSYS_0000013194": "工作台",
        "P_YS_PF_GZTSYS_0001025942": "门户广告位设置",
        "P_YS_IPAAS_UCG_0001064361": "农、林、牧、渔业",
        "P_YS_OA_XTTXL_0000045990": "管理",
        "P_YS_FED_UCFBASEDOC_0000025619": "添加文件夹",
        "P_YS_IPAAS_UCG_0001064369": "国际组织",
        "P_YS_FED_IMP_IOT0000008165": "删除",
        "P_YS_FED_UCFBASEDOC_0000025614": "手机",
        "P_YS_IPAAS_UCG_0001064009": "住宿、餐饮业",
        "P_YS_FED_FW_0000022366": "修改成功！",
        "P_YS_PF_WORKBENCH-FE_0001229374": "广告位资源可在“门户广告位设置”中设置",
        "P_YS_PF_WORKBENCH-FE_0001229373": "存在多张广告图时，设定图片播放间隔",
        "P_YS_PF_WORKBENCH-FE_0001229377": "是否启用自定义",
        "P_YS_PF_WORKBENCH-FE_0001229376": "关联广告",
        "P_YS_PF_WORKBENCH-FE_0001229375": "图片轮播间隔",
        "P_YS_IPAAS_UCG_0001064490": "文化、体育、娱乐业",
        "P_YS_PF_WORKBENCH-FE_0001229379": "搜索应用名称",
        "P_YS_IPAAS_UCG_0001064251": "卫生、社会保障和社会服务业",
        "P_YS_OA_XTMENHUCMS_0000045298": "图片样式",
        "P_YS_OA_XTMENHUCMS_0000045174": "广告位",
        "P_YS_IPAAS_UCG_0001064138": "电力、热力、燃气及水的生产和供应业",
        "P_YS_FED_UCFBASEDOC_0000024755": "删除文件夹",
        "P_YS_FED_UCFBASEDOC_0000025601": "请输入邮箱",
        "P_YS_FED_UCFBASEDOC_0000024752": "您确认要删除此项服务？",
        "P_YS_FED_UCFBASEDOC_0000024870": "查看详情",
        "P_YS_PF_AUTHF_0000080113": "10条/页",
        "P_YS_FED_FW_0000021020": "新增",
        "P_YS_OA_XTMENHUCMS_0000045290": "背景颜色",
        "P_YS_SD_SDMAUF_0000152315": "之后",
        "P_YS_OA_XTMENHUCMS_0000045287": "常用应用",
        "P_YS_OA_XTMENHUCMS_0000045284": "图标大小设置",
        "P_YS_OA_XTMENHUCMS_0000045041": "组件名称",
        "P_YS_FED_UCFBASEDOC_0000024748": "您确认要批量删除吗？",
        "P_YS_PF_GZTLOG_0000080270": "Web端",
        "P_YS_FED_UCFBASEDOC_0000024866": "是否保存最新修改？",
        "P_YS_FED_FW_0000022466": "默认",
        "P_YS_FED_FW_0000021376": "中国",
        "P_YS_OA_XTSPZX_0000034639": "领域",
        "P_YS_FED_FW_0000021379": "北京",
        "P_YS_FED_UCFBASEDOC_0000024982": "不保存",
        "P_YS_OA_XTMENHUCMS_0000045168": "消息中心",
        "P_YS_SCM_STOCK_0000034455": "未读",
        "P_YS_PF_WORKBENCH-FE_0001241019": "工作台",
        "P_YS_OA_XTTMCENTER_0000035108": "用友云市场",
        "P_YS_PF_MANAGER-FE_0001120439": "错误的参数：applicationId",
        "P_YS_PF_GZTLOG_0000025976": "锁定",
        "P_YS_FED_FW_0000022475": "所属行业",
        "P_YS_SD_SDMBF_0000144334": "请上传图片",
        "P_YS_OA_XTMENHUCMS_0000045158": "工作门户",
        "P_YS_FI_CM_0000029097": "今天",
        "P_YS_FI_FA_0000056249": "新增卡片",
        "P_YS_FED_EXAMP_0000020397": "姓名",
        "P_YS_FED_FW_0000022168": "请输入关键字",
        "P_YS_PF_AUTHF_0000080120": "15条/页",
        "P_YS_OA_XTLCZX_0000030221": "系统",
        "P_YS_FED_FW_0000022064": "暂无数据",
        "P_YS_IPAAS_UCG_0001064293": "批发和零售业",
        "P_YS_PF_WORKBENCH-FE_0001202943": "固定导航",
        "P_YS_PF_WORKBENCH-FE_0001202944": "菜单锁定",
        "P_YS_PF_WORKBENCH-FE_0001202945": "导航切换",
        "P_YS_PF_WORKBENCH-FE_0001202946": "解除固定",
        "P_YS_PF_WORKBENCH-FE_0001202941": "快捷导航",
        "P_YS_PF_WORKBENCH-FE_0001202942": "全局导航",
        "country886": "中国台湾",
        "P_YS_FI_FCWEB_0001048065": "工作台设置",
        "P_YS_PF_GZTSYS_0000011939": "我的门户管理",
        "P_YS_SD_SDMB_0000146348": "服务支持",
        "P_YS_FED_FW_0000022179": "对齐方式",
        "P_YS_PF_WORKBENCH-FE_0001202947": "快捷导航设置",
        "P_YS_FED_UCFBASEDOC_0000024951": "无内容的分组在首页不可见",
        "P_YS_OA_XTLCZX_0000030219": "搜索结果",
        "P_YS_PF_GZTSYS_0000012902": "其它",
        "P_YS_SD_SDMAUF_0000152873": "历史记录",
        "P_YS_PF_PROCENTER_0000022591": "校验失败",
        "P_YS_PF_WORKBENCH-FE_0001212762": "快捷搜索",
        "P_YS_SCM_STOCK_0000034523": "已读",
        "P_YS_SD_SDMAUF_0000152518": "还有",
        "P_YS_FED_EXAMP_0000020183": "关闭",
        "P_YS_PF_WORKBENCH-FE_0001153504": "不再提醒",
        "P_YS_PF_WORKBENCH-FE_0001137268": "忽略，不再提醒",
        "P_YS_FED_UCFBASEDOC_0000024820": "到",
        "P_YS_FED_UCFBASEDOC_0000024942": "添加",
        "P_YS_OA_app_xtyyjm_0000035755": "待审批",
        "P_YS_OA_XTLCZX_0000030480": "小",
        "P_YS_FED_UCFBASEDOC_0000024938": "删除服务",
        "P_YS_FED_UCFBASEDOC_0000024930": "请输入联系人姓名",
        "P_YS_OA_XTLCZX_0000030238": "背景图片",
        "P_YS_OA_app_xtyyjm_0000035750": "成员",
        "P_YS_PF_WORKBENCH-FE_0001212760": "”相关结果，请重新输入",
        "P_YS_PF_WORKBENCH-FE_0001212761": "未搜索到“",
        "P_YS_PF_WORKBENCH-FE_0001233364": "工作台个性化配置能力增强",
        "P_YS_SD_SDMB_0000139191": "消息详情",
        "P_YS_PF_WORKBENCH-FE_0001233363": "支持更多磁贴、更灵活布局、更丰富的展示效果",
        "P_YS_PF_WORKBENCH-FE_0001233362": "门户合并到工作台啦，支持多工作台切换，角色化工作台帮助您更好完成工作任务",
        "P_YS_PF_MANAGER-FE_0001087832": "申请权限",
        "P_YS_PF_WORKBENCH-FE_0001233361": "企业帐号换位置啦",
        "P_YS_FED_UCFBASEDOC_0000025581": "重命名分组",
        "P_YS_PF_WORKBENCH-FE_0001233360": "数字化工作入口升级啦",
        "P_YS_OA_XTMENHUCMS_0000044935": "发言",
        "P_YS_PF_GZTSYS_0000109255": "获取验证码失败",
        "P_YS_PLM_BASE-FE_0001160596": "顶部对齐",
        "P_YS_OA_XTMENHUCMS_0000044934": "长广告位",
        "P_YS_OA_YBMOB_0000036991": "审批详情",
        "P_YS_SD_SDMA_0000123136": "主页",
        "P_YS_PF_MANAGER-FE_0001087834": "请输入在友空间APP打开时跳转地址",
        "P_YS_PF_MANAGER-FE_0001087957": "请输入Android下载地址",
        "P_YS_PF_MANAGER-FE_0001087836": "请输入IOS下载地址",
        "P_YS_FED_EXAMP_0000020115": "切换",
        "P_YS_FED_EXAMP_0000020236": "复制链接",
        "P_YS_OA_XTMENHU_0000046746": "预警通知",
        "P_YS_OA_XTMENHU_0000046620": "链接名称",
        "P_YS_SD_UDHMC_0000051143": "请输入企业名称",
        "P_YS_PF_WORKBENCH-FE_0001233359": "菜单导航优化",
        "P_YS_PF_WORKBENCH-FE_0001233358": "企业帐号转移到用户下拉面板啦",
        "P_YS_FED_UCFBASEDOC_0000025215": "登录",
        "P_YS_PF_WORKBENCH-FE_0001233357": "工作台配置能力更强，菜单导航更高效",
        "P_YS_PF_WORKBENCH-FE_0001233356": "支持多工作台",
        "P_YS_PF_WORKBENCH-FE_0001233355": "全新的菜单面板，新增搜索功能，支持快速收藏和查看最近使用",
        "P_YS_OA_app_xtywlj_0000037879": "所属分类",
        "P_YS_PF_MANAGER-FE_0001087842": "跳转参数",
        "P_YS_PF_WORKBENCH-FE_0001133407": "全部历史",
        "P_YS_PF_MANAGER-FE_0001087841": "全员邀请",
        "P_YS_PF_WORKBENCH-FE_0001133408": "用友云，完全公有云化的企业服务，让我从传统的运维 工作解放出来，成为公司数据资产的建设者",
        "P_YS_PF_MANAGER-FE_0001087844": "请选择是否原生",
        "P_YS_PF_WORKBENCH-FE_0001133405": "开启录制",
        "P_YS_PF_MANAGER-FE_0001087964": "PC客户端主页",
        "P_YS_PF_MANAGER-FE_0001087843": "请输入上传到iUAP平台的安装包ID",
        "P_YS_PF_WORKBENCH-FE_0001133406": "搜索人员信息、服务及其他内容",
        "P_YS_OA_XTWEIYOU_0000046270": "同时发送邮件",
        "P_YS_FED_FW_0000055346": "请选择数据",
        "P_YS_PF_MANAGER-FE_0001087840": "Web端主页",
        "P_YS_PF_MANAGER-FE_0001087961": "是否常用应用",
        "P_YS_PF_WORKBENCH-FE_0001133409": "移除首页",
        "P_YS_PF_WORKBENCH-FE_0001133400": "个应用已到期，",
        "P_YS_FI_CM_0000029500": "页",
        "P_YS_PF_MANAGER-FE_0001087846": "是否离线应用",
        "P_YS_PF_WORKBENCH-FE_0001133403": "团队设置",
        "P_YS_PF_MANAGER-FE_0001087966": "上下级显示",
        "P_YS_PF_WORKBENCH-FE_0001133404": "让我从很多重复性的事务工作中解放出来",
        "P_YS_PF_MANAGER-FE_0001087848": "邀请规则",
        "P_YS_PF_WORKBENCH-FE_0001133401": "背景色定义",
        "P_YS_PF_MANAGER-FE_0001087847": "请输入在Web浏览器打开时跳转地址",
        "P_YS_PF_WORKBENCH-FE_0001133402": "更多结果",
        "P_YS_FED_EXAMP_0000020005": "模板",
        "P_YS_PF_WORKBENCH-FE_0001242095": "还未添加收藏,快去收藏吧",
        "P_YS_PF_WORKBENCH-FE_0001242096": "暂不了解",
        "P_YS_PF_GZTSYS_0000013477": "保存",
        "P_YS_PF_METADATA_0000084364": "请求地址",
        "P_YS_PF_GZTSYS_0000015896": "团队成员",
        "P_YS_FI_CM_0000028899": "退出登录",
        "P_YS_OA_XTLCZX_0000030776": "正常",
        "P_YS_FED_UCFBASEDOC_0000025203": "获取验证码",
        "P_YS_PF_WORKBENCH-FE_0001233465": "开始了解",
        "P_YS_OA_XTMENHU_0000046739": "我的任务",
        "P_YS_OA_XTMENHU_0000046618": "我的项目",
        "P_YS_FED_UCFBASEDOC_0000025200": "移动",
        "P_YS_OA_XTNEIBUQUN_0000046122": "设置管理员",
        "P_YS_PF_WORKBENCH-FE_0001133418": "每天维护公司的上百台服务器，总是怕出现一些问题， 影响公司业务发展",
        "P_YS_PF_MANAGER-FE_0001087852": "请上传服务图标",
        "P_YS_PF_WORKBENCH-FE_0001133419": "填写信息",
        "P_YS_HR_HRSBF_0001183870": "个人设置",
        "P_YS_PF_WORKBENCH-FE_0001133416": "发布到菜单",
        "P_YS_PF_WORKBENCH-FE_0001133417": "邮箱：diwork@yonyou.com",
        "P_YS_OA_XTLCZX_0000030555": "平铺",
        "P_YS_PF_WORKBENCH-FE_0001232171": "剩余数",
        "P_YS_PF_WORKBENCH-FE_0001232170": "更早",
        "P_YS_PF_WORKBENCH-FE_0001133410": "“相信美好，立刻开始数字化工作”",
        "P_YS_PF_WORKBENCH-FE_0001133411": "关闭录制",
        "P_YS_PF_WORKBENCH-FE_0001133414": "中查看。",
        "P_YS_PF_WORKBENCH-FE_0001133415": "当前租户已开启登录控制策略。控制方式为【验证码】",
        "P_YS_PF_WORKBENCH-FE_0001133412": "帐号管理",
        "P_YS_OA_YBMOB_0000036890": "文件",
        "P_YS_PF_MANAGER-FE_0001087858": "置顶优先级",
        "P_YS_PF_WORKBENCH-FE_0001133413": "如需购买或了解产品详情请拨打热线",
        "P_YS_FED_EXAMP_0000020016": "首页",
        "P_YS_OA_XTMENHU_0000046646": "链接邀请",
        "P_YS_SD_SDMA_0000098308": "页面设置",
        "P_YS_OA_XTMENHU_0000046524": "待办中心",
        "P_YS_PF_WORKBENCH-FE_0001245211": "左右排列",
        "P_YS_PF_GZTSYS_0000013325": "标签",
        "P_YS_OA_XTMENHU_0000046644": "空间管理",
        "P_YS_OA_XTMENHU_0000046523": "图文模式",
        "P_YS_FED_UCFBASEDOC_0000025319": "验证码",
        "P_YS_PF_METADATA_0000085782": "产品编码",
        "P_YS_HR_HRJQF_0000054364": "导入完成",
        "P_YS_OA_app_xtyyjm_0000035782": "选择报表",
        "P_YS_PF_WORKBENCH-FE_0001232168": "获取数据异常，请刷新",
        "P_YS_OA_app_xtywlj_0000037618": "业务",
        "P_YS_PF_WORKBENCH-FE_0001232169": "占用率",
        "P_YS_PF_WORKBENCH-FE_0001232166": "授权占用明细",
        "P_YS_PF_WORKBENCH-FE_0001232167": "授权数",
        "P_YS_HR_HRCOREF_0000058092": "当前人数",
        "P_YS_PF_WORKBENCH-FE_0001133429": "扫描二维码直接进入",
        "P_YS_PF_WORKBENCH-FE_0001232164": "消息分类",
        "P_YS_PF_MANAGER-FE_0001087863": "相关操作",
        "P_YS_PF_WORKBENCH-FE_0001133309": "系统：仅企业账号管理员可见",
        "P_YS_PF_WORKBENCH-FE_0001232165": "最近三天",
        "P_YS_PF_WORKBENCH-FE_0001133427": "升级为企业",
        "P_YS_PF_MANAGER-FE_0001087865": "pc客户端内",
        "P_YS_PF_WORKBENCH-FE_0001133428": "菜单名称：",
        "P_YS_OA_XTLCZX_0000030680": "我发起的",
        "P_YS_PF_WORKBENCH-FE_0001232163": "部署费",
        "P_YS_OA_XTLCZX_0000030202": "大",
        "P_YS_PF_WORKBENCH-FE_0001133421": "用友云提供了企业所需要的各种数字化服务",
        "P_YS_PF_WORKBENCH-FE_0001133422": "全局搜索：",
        "P_YS_FED_EXAMP_0000020395": "搜索",
        "P_YS_PF_WORKBENCH-FE_0001133420": "联系邮箱：diwork@yonyou.com",
        "P_YS_IPAAS_UCG_0001064071": "交通运输、仓储业和邮政业",
        "P_YS_SD_SDMAUF_0000151876": "请填写",
        "P_YS_PF_MANAGER-FE_0001087868": "请选择所属行业",
        "P_YS_PF_WORKBENCH-FE_0001133425": "定制服务",
        "P_YS_PF_MANAGER-FE_0001087867": "图标尺寸须为120*120，且不大于5M！",
        "P_YS_PF_WORKBENCH-FE_0001133426": "遍布全国的专业售前团队，整装待命",
        "P_YS_FED_EXAMP_0000020391": "加载中...",
        "P_YS_PF_WORKBENCH-FE_0001133423": "菜单位置：",
        "P_YS_PF_WORKBENCH-FE_0001245212": "上下排列",
        "P_YS_PF_WORKBENCH-FE_0001133424": "个应用，",
        "P_YS_SD_SDMB-UI_0001160783": "显示头像",
        "P_YS_PF_YHTTNT-FE_0001045676": "只显示管理员",
        "P_YS_FED_EXAMP_0000020385": "取消",
        "P_YS_PF_WORKBENCH-FE_0001145762": "已知晓，不再提示",
        "P_YS_FED_FW_0000022510": "恢复默认",
        "P_YS_OA_XTLCZX_0000030679": "中",
        "P_YS_PF_WORKBENCH-FE_0001145764": "您购买的产品即将过期",
        "P_YS_PF_WORKBENCH-FE_0001145763": "您购买的产品已经到期",
        "P_YS_SD_SDMB_0000146962": "返回顶部",
        "P_YS_PF_WORKBENCH-FE_0001145765": "立即查看",
        "P_YS_FED_FW_0000022512": "没有搜索结果",
        "P_YS_PF_WORKBENCH-FE_0001233366": "支持回到旧版，可以随时切换回到新版工作台",
        "P_YS_PF_WORKBENCH-FE_0001233365": "切换旧版工作台",
        "P_YS_PF_MANAGER-FE_0001087877": "中国香港特别行政区",
        "P_YS_FED_UCFBASEDOC_0000024690": "分组名称,最多4个字符",
        "P_YS_PF_MANAGER-FE_0001087870": "规模范围",
        "P_YS_PF_MANAGER-FE_0001087873": "禁止邀请",
        "P_YS_FI_CM_0000029930": "我知道了",
        "P_YS_PF_MANAGER-FE_0001087872": "不能多于6个汉字或者12个字母",
        "P_YS_PF_PROCENTER_0000023062": "其他",
        "P_YS_HR_HRPXF_0000055999": "发荣耀",
        "P_YS_FED_IMP_IOT0000005499": "全部",
        "OA_web_footer_000000023": "京公网安备 11010802021935号",
        "P_YS_FED_UCFBASEDOC_0000025417": "重命名文件夹",
        "P_YS_FED_FW_0000022200": "当前",
        "P_YS_PF_PROCENTER_0000026339": "联系人信息",
        "P_YS_OA_XTLCZX_0000030607": "拉伸",
        "P_YS_HR_HRJQF_0000054222": "日期范围",
        "P_YS_FED_FW_0000022205": "下移",
        "P_YS_PF_MANAGER-FE_0001087885": "企业头像",
        "P_YS_PF_MANAGER-FE_0001087882": "下载地址",
        "P_YS_PF_MANAGER-FE_0001087884": "禁止",
        "P_YS_PF_MANAGER-FE_0001087883": "推荐到移动端首页",
        "P_YS_FED_IMP-DFM-FE_0000020888": "序号",
        "P_YS_PF_GZTTMP_0000073996": "教育",
        "P_YS_OA_XTNEIBUQUN_0000046136": "邀请成员",
        "P_YS_FED_EXAMP_0000020566": "微信",
        "P_YS_PF_METADATA_0000084287": "占用数",
        "P_YS_OA_XTSPZX_0000034688": "数据来源",
        "P_YS_FED_UCFBASEDOC_0000025523": "分组名称已存在！",
        "P_YS_FED_EXAMP_0000020207": "通过",
        "P_YS_FED_FW_0000022215": "分组",
        "P_YS_FED_UCFBASEDOC_0000025400": "您确认要删除此项？",
        "P_YS_PF_MANAGER-FE_0001087899": "上传图标失败！",
        "P_YS_PF_MANAGER-FE_0001087893": "最多60个字符",
        "P_YS_PF_WORKBENCH-FE_0001155883": "您购买的产品中，有应用即将到期，请及时安排续费！",
        "P_YS_PF_MANAGER-FE_0001087895": "集成免登策略",
        "P_YS_PF_WORKBENCH-FE_0001155882": "您购买的产品中，有应用已到期，请尽快安排续费！",
        "P_YS_PF_GZTSYS_0000013012": "应用设置",
        "P_YS_OA_XTMENHU_0000046601": "最多添加19个应用",
        "P_YS_OA_XTMENHU_0000046725": "添加链接",
        "P_YS_SD_SDMA_0000041132": "已过期",
        "P_YS_OA_XTSPZX_0000034674": "添加应用",
        "P_YS_PF_AUTHF_0000112877": "输入服务名称",
        "P_YS_PF_GZTLOG_0000028817": "请求失败",
        "P_YS_OA_XTMENHU_0000046721": "祝你生日快乐，永远十八岁！",
        "P_YS_PF_GZTSYS_0000013245": "服务类型",
        "P_YS_PF_MANAGER-FE_0001087891": "根据组织机构负责人显示上下级",
        "P_YS_FED_IMP_IOT0000005471": "提示",
        "P_YS_OA_XTMENHU_0000046605": "待办审批",
        "P_YS_PF_GZTTMP_0000079164": "消息状态",
        "P_YS_PF_MANAGER-FE_0001087788": "退出企业",
        "P_YS_PF_METADATA_0000088627": "问题反馈",
        "P_YS_OA_XTSPZX_0000034661": "移动端",
        "P_YS_OA_XTMENHU_0000046711": "二维码邀请",
        "P_YS_FI_CM_0000029607": "错误",
        "P_YS_PF_WORKBENCH-FE_0001204986": "请输入服务名称(最多15个汉字)",
        "P_YS_FED_EXAMP_0000020462": "清空",
        "P_YS_FED_EXAMP_0000020344": "否",
        "P_YS_OA_XTMENHU_0000046710": "个人生日哦",
        "P_YS_FI_GL_0000088728": "允许",
        "P_YS_FED_FW_0001097161": "页面中有未保存的数据，点击确定后将关闭页面，是否继续？",
        "P_YS_PF_AUTHF_0000112885": "暂无结果",
        "P_YS_PF_GZTSYS_0000109539": "繁體中文"
    }
}